const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
          codeSent: "Código de verificação enviado para seu e-mail!",
          codeResent: "Novo código enviado!"
        },
        form: {
          name: "Nome",
          email: "E-mail",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        plan: {
          title: "Escolha seu Plano",
          subtitle: "Selecione o plano ideal para sua empresa",
          badge: "Ideal para sua empresa",
          period: "mês",
          meta: "Até {{users}} usuários · Até {{connections}} conexões"
        },
        formStep: {
          title: "Criar sua conta",
          subtitle: "Preencha os dados da sua empresa"
        },
        verify: {
          title: "Verificação de E-mail",
          subtitle: "Digite o código de 6 dígitos enviado para",
          confirm: "Verificar e Criar Conta",
          sending: "Enviando...",
          resend: "Reenviar código",
          resendIn: "Reenviar em"
        },
        actions: {
          continue: "Continuar",
          back: "Voltar",
          hasAccount: "Já tem uma conta?",
          enter: "Entrar"
        },
        document: {
          label: "CPF / CNPJ / Documento (opcional)",
          cpfValid: "CPF válido!",
          cnpjValid: "CNPJ válido! Nome preenchido automaticamente.",
          invalid: "Documento inválido.",
          error: "Erro ao validar documento."
        },
        validation: {
          required: "Campo obrigatório",
          nameMin: "Nome deve ter pelo menos 2 caracteres",
          nameMax: "Nome deve ter no máximo 50 caracteres",
          companyMin: "Empresa deve ter pelo menos 2 caracteres",
          companyMax: "Empresa deve ter no máximo 50 caracteres",
          passwordMin: "Senha deve ter pelo menos 5 caracteres",
          passwordMax: "Senha deve ter no máximo 50 caracteres",
          invalidEmail: "E-mail inválido",
          codeLength: "Digite o código completo de 6 dígitos."
        },
        features: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          integrations: "Integrações",
          openAi: "OpenAI",
          kanban: "Kanban"
        }
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        forgotPassword: "Esqueceu sua senha?",
        form: {
          email: "E-mail",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem uma conta? Cadastre-se!",
        },
        footer: "Todos os direitos reservados.",
      },
      forgotPassword: {
        title: "Recuperar acesso",
        subtitleLine1: "Informe o e-mail vinculado à sua conta.",
        subtitleLine2: "Enviaremos um código de verificação para você.",
        email: "E-mail",
        placeholder: "seu.email@exemplo.com",
        sending: "Enviando...",
        send: "Enviar Código",
        back: "Voltar para o login",
        toasts: {
          requiredEmail: "Digite seu e-mail",
          success: "Se o e-mail estiver cadastrado, um código será enviado.",
          error: "Erro ao enviar código. Verifique se o SMTP está configurado nas configurações."
        }
      },
      validateCode: {
        title: "Verifique seu e-mail",
        subtitle: "Enviamos um código de 6 dígitos para",
        label: "Código de Verificação",
        submitting: "Validando...",
        submit: "Verificar Código",
        resendPrompt: "Não recebeu? Reenviar código",
        back: "Voltar",
        toasts: {
          incomplete: "Digite o código completo de 6 dígitos",
          success: "Código validado com sucesso!",
          error: "Código inválido ou expirado. Tente novamente.",
          resent: "Novo código enviado!",
          resentError: "Erro ao reenviar código."
        }
      },
      resetPassword: {
        title: "Criar nova senha",
        subtitleLine1: "Escolha uma senha segura para",
        subtitleLine2: "proteger sua conta.",
        newPassword: "Nova Senha",
        confirmPassword: "Confirmar Senha",
        passwordPlaceholder: "Digite sua nova senha",
        confirmPlaceholder: "Repita a nova senha",
        minHint: "Mínimo de 6 caracteres",
        submitting: "Salvando...",
        submit: "Redefinir Senha",
        successTitle: "Senha redefinida com sucesso!",
        successSubtitle: "Redirecionando para o login...",
        toasts: {
          minLength: "A senha deve ter no mínimo 6 caracteres",
          mismatch: "As senhas não coincidem",
          success: "Senha redefinida com sucesso!",
          error: "Erro ao redefinir senha. Token inválido ou expirado."
        }
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir Empresa",
          deleteMessage: "Tem certeza que deseja excluir esta empresa? Todos os dados relacionados serão perdidos. Esta ação não pode ser desfeita.",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
          warning: "Sua assinatura vence em {{days}} {{unit}}",
          expired: "Sua assinatura venceu em {{date}}. Entre em contato com o Suporte para mais informações!",
        },
        token: "Token",
      },
      dashboard: {
        subtitle: "Visão geral dos indicadores de atendimento",
        fetchError: "Erro ao carregar dados do dashboard",
        hideFilters: "Ocultar Filtros",
        filters: "Filtros",
        filter: "FILTRAR ",
        npsTitle: "Pesquisa de Satisfação (NPS)",
        calls: "Atendimentos",
        analytics: {
          title: "Análises",
          ticketVolume: "Volume de Tickets",
          lastDays: "Últimos {{days}} dias",
          noData: "Sem dados",
          ticketStatus: "Status dos Tickets",
          distributionByStatus: "Distribuição por status",
          noTickets: "Sem tickets",
          conversationMetrics: "Métricas de Conversas",
          activeContacts: "Contatos Ativos",
          ticketsPerContact: "Tickets/Contato",
          days: "dias",
          ratingRate: "Taxa Avaliação",
          hourlyActivity: "Atividade por Hora",
          less: "Menos",
          more: "Mais",
          topContacts: "Top Contatos",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatórios de Atendimentos",
        subtitle: "Visualize e exporte dados dos atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        searchPlaceholder: "Pesquisar...",
        saleValue: "Valor da Venda",
        noSaleReason: "Motivo da Não Venda",
        closedWithSale: "Finalizado com Venda",
        yes: "Sim",
        no: "Não",
        ticketLogs: "Logs do Ticket",
        accessTicket: "Acessar Ticket",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        newConnection: "Nova Conexão",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",
        integrity: "Integridade",
        stable: "Estável",
        unstable: "Instável",
        statusConnected: "Conectado",
        statusDisconnected: "Desconectado",
        statusOpening: "Conectando",
        statusQrcode: "QR Code",
        statusPairing: "Pareando",
        active: "Ativo",
        inactive: "Inativo",
        updatedAt: "Atualizado",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
          receiveComments: "Receber Comentários",
        },
        receiveComments: {
          label: "Receber Comentários",
          enabled: "Recebimento de comentários habilitado",
          disabled: "Recebimento de comentários desabilitado",
          tooltip: {
            enabled: "Comentários estão sendo recebidos. Clique para desabilitar.",
            disabled: "Comentários não estão sendo recebidos. Clique para habilitar.",
          },
        },
        transfer: {
          title: "Transferência de Tickets",
          description: "Selecione a conexão de origem e a de destino. Todos os atendimentos ativos serão movidos.",
          source: "Origem",
          target: "Destino",
          cancel: "Cancelar",
          transfer: "Transferir",
          transferTickets: "Transferir Tickets",
          transferring: "Transferindo Tickets",
          of: "de",
          waitMessage: "Aguarde enquanto os tickets são transferidos...",
          selectConnections: "Selecione as conexões de origem e destino",
          differentConnections: "As conexões de origem e destino devem ser diferentes",
          success: "Tickets transferidos com sucesso! {{count}} tickets transferidos.",
        },
        preDelete: {
          title: "Antes de excluir",
          message: "Você já transferiu os tickets desta conexão para outra? Se não, recomendamos transferir antes de excluir.",
          notYet: "Ainda não",
          yesTransferred: "Sim, já transferi",
        },
        importMessages: {
          title: "Importar Mensagens",
          button: "Importar Mensagens",
          connection: "Conexão",
          selectConnection: "Selecione uma conexão Z-API",
          startDate: "Data Início",
          endDate: "Data Fim",
          messageType: "Tipo de Mensagem",
          all: "Todas",
          individual: "Individual",
          group: "Grupo",
          ticketStatus: "Status do Ticket",
          open: "Aberto",
          closed: "Fechado",
          import: "Importar",
          cancel: "Cancelar",
          importing: "Importando mensagens...",
          importingDescription: "Aguarde enquanto as mensagens são importadas. Isso pode levar alguns minutos.",
          success: "Importação concluída! {{messages}} mensagens, {{tickets}} tickets, {{contacts}} contatos importados.",
          noZApiConnections: "Nenhuma conexão Z-API encontrada.",
          noConnections: "Nenhuma conexão WhatsApp conectada encontrada.",
          errorMissingFields: "Preencha todos os campos obrigatórios.",
        },
        nativeImport: {
          importing: "Importando mensagens do WhatsApp...",
          finishing: "Finalizando importação...",
          processed: "Processadas",
          messages: "mensagens",
          currentDate: "Data atual",
          errors: "erros",
          cancelled: "Importação cancelada",
          cancel: "Cancelar",
        },
        importProgress: {
          done: "Importação concluída!",
          cancelled: "Importação cancelada",
          importing: "Importando mensagens...",
          starting: "Conectando...",
          scanning: "Buscando chats...",
          processingChat: "Processando chat {{current}} de {{total}}",
          allProcessed: "Todos os chats foram processados",
          cancelledAt: "Parado em {{current}} de {{total}} chats",
          initializing: "Iniciando...",
          progress: "Progresso",
          chats: "chats",
          messagesLabel: "Mensagens",
          tickets: "Tickets",
          contacts: "Contatos",
          errorsLabel: "Erros",
          cancelImport: "Cancelar Importação",
          close: "Fechar",
        },
        officialLabel: "Oficial",
        badges: {
          pairingCode: "Conectado via Código de Pareamento",
          qrCode: "Conectado via QR Code",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
          chatbot: "Chatbot",
          defaultFlow: "Fluxo Padrão",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      qrcodeModal: {
        title: "Conectar ao WhatsApp",
        subtitle: "Escaneie o QR Code com seu celular para iniciar a sessão",
        connected: "Conectado com sucesso!",
        generating: "Gerando novo QR Code...",
        step1: "Abra o <strong>WhatsApp</strong> no seu celular",
        step2Options: "Toque em <strong>Mais opções ⋮</strong> ou <strong>Configurações ⚙</strong> e selecione <strong>Aparelhos conectados</strong>",
        step3: "Toque em <strong>Conectar um aparelho</strong> e aponte a câmera para este QR Code",
        refreshCountdown: "QR Code atualiza em {{seconds}}s",
        refreshing: "Atualizando QR Code...",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Agente salvo com sucesso!",
        title: {
          add: "Criar Agente",
          edit: "Editar Agente",
        },
        subtitle: "Configure os parâmetros do agente de IA",
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        tabs: {
          basic: "Básico",
          behavior: "Comportamento",
          advanced: "Avançado",
          knowledge: "📚 Conhecimento",
          test: "🧪 Testar",
        },
        basic: {
          agentName: "Nome do Agente *",
          agentNamePlaceholder: "Ex: Assistente de Vendas",
          function: "Função",
          voiceTone: "Tom de Voz",
          aiModel: "Modelo de IA",
          apiKey: "API Key *",
          responseLanguages: "🌐 Idiomas de resposta",
          responseLanguagesHelp: "Selecione os idiomas em que a IA pode responder. Use \"Auto\" para responder no idioma do cliente automaticamente.",
          personality: "Personalidade",
          personalityPlaceholder: "Descreva a personalidade, conhecimentos e habilidades do agente",
          personalityHelp: "Descreva a personalidade, conhecimentos e habilidades do agente",
          activeAgent: "Agente Ativo",
        },
        behavior: {
          greetingMessage: "Mensagem Inicial (opcional)",
          greetingPlaceholder: "Olá! Como posso ajudá-lo?",
          greetingHelp: "Mensagem enviada automaticamente quando o agente inicia uma conversa",
          responseRules: "Regras de Resposta",
          responseRulesPlaceholder: "Liste regras específicas que o agente deve seguir",
          responseRulesHelp: "Liste regras específicas que o agente deve seguir",
          allowTransfer: "Permitir transferência para atendente",
          transferKeywords: "Palavras-chave para transferência",
          transferKeywordsPlaceholder: "atendente, sair, falar com humano, humano",
          transferKeywordsHelp: "Separe por vírgula. Quando detectadas, a IA transfere para um atendente",
          transferKeywordsDefault: "atendente, sair, falar com humano, humano",
          transferMessage: "Mensagem ao transferir",
          transferMessagePlaceholder: "Desculpe, não tenho informações sobre esse assunto. Vou transferir para um atendente.",
          transferMessageDefault: "Desculpe, não tenho informações sobre esse assunto. Vou transferir para um atendente.",
        },
        advanced: {
          responseDelay: "Delay de Resposta",
          responseDelayHelp: "Tempo de espera antes de enviar a resposta (simula digitação)",
          charLimit: "Limite de caracteres",
          charLimitHelp: "Tamanho máximo da resposta do agente",
          humanize: "✨ Humanizar conversa",
          humanizeHelp: "Alterna entre primeiro nome, nome completo e sem nome para parecer natural",
          audioFeatures: "🔊 Recursos de Áudio",
          transcribeAudio: "Transcrever áudios recebidos",
          transcribeAudioHelp: "Converte mensagens de áudio em texto para o agente entender",
          responseMode: "Modo de Resposta",
          agentVoice: "Voz do Agente",
          sendAsPTT: "Enviar como áudio gravado (PTT)",
          sendAsPTTHelp: "O áudio aparece como se fosse gravado na hora, igual um áudio de WhatsApp",
          temperatureHelp: "0 = preciso, 2 = criativo",
          maxTokens: "Max Tokens",
          maxMessages: "Max Mensagens",
        },
        knowledge: {
          title: "Base de Conhecimento",
          subtitle: "Adicione textos, URLs, PDFs, áudios e vídeos para o agente usar como referência",
          upload: "Upload",
          add: "Adicionar",
          saveFirst: "Salve o agente primeiro para adicionar itens à base de conhecimento",
          newItem: "Novo Item",
          nameLabel: "Nome",
          textType: "📋 Texto",
          urlType: "🔗 URL",
          urlLabel: "URL do site",
          textLabel: "Conteúdo de texto",
          urlPlaceholder: "https://exemplo.com/pagina",
          textPlaceholder: "Cole aqui o texto de referência...",
          cancelBtn: "Cancelar",
          saveBtn: "Salvar",
          empty: "Nenhum item na base de conhecimento",
          emptyHelp: "Adicione textos, URLs ou faça upload de arquivos",
          noContent: "Sem conteúdo",
          fillNameContent: "Preencha o nome e o conteúdo",
          addedSuccess: "Item adicionado à base de conhecimento!",
          uploadSuccess: "Arquivo enviado com sucesso!",
          removeConfirm: "Tem certeza que deseja remover este item?",
          removeSuccess: "Item removido!",
        },
        test: {
          model: "Modelo",
          usingApiKey: "Usando API Key e prompt da aba \"Básico\"",
          clear: "Limpar",
          emptyChat: "💬 Envie uma mensagem para testar seu Agente de IA",
          placeholder: "Digite sua mensagem de teste...",
          fillApiKey: "Preencha a API Key antes de testar",
          fillPrompt: "Preencha a personalidade/prompt antes de testar",
          fillApiKeyVoice: "Preencha a API Key na aba Básico para ouvir o preview da voz",
          voiceError: "Erro ao gerar preview da voz. Verifique a API Key.",
        },
        functions: {
          geral: "Geral",
          geralDesc: "Assistente multiuso",
          vendas: "Vendas",
          vendasDesc: "Focado em conversão",
          suporte: "Suporte",
          suporteDesc: "Atendimento técnico",
          agendamento: "Agendamento",
          agendamentoDesc: "Marcação de horários",
          financeiro: "Financeiro",
          financeiroDesc: "Cobranças e pagamentos",
        },
        voiceTones: {
          amigavel: "😊 Amigável",
          profissional: "💼 Profissional",
          formal: "🎩 Formal",
          casual: "😎 Casual",
          empatico: "🤗 Empático",
          tecnico: "🔧 Técnico",
        },
        responseModes: {
          text: "Apenas Texto",
          textDesc: "Responde somente com texto",
          audio: "Apenas Áudio",
          audioDesc: "Responde somente com áudio",
          both: "Texto e Áudio",
          bothDesc: "Responde com ambos",
        },
        agentVoices: {
          alloyDesc: "Neutra e equilibrada",
          ashDesc: "Masculina, suave",
          balladDesc: "Feminina, expressiva",
          coralDesc: "Feminina, clara",
          echoDesc: "Masculina, profunda",
          fableDesc: "Masculina, britânica",
          onyxDesc: "Masculina, grave",
          novaDesc: "Feminina, energética",
          sageDesc: "Masculina, calma",
          shimmerDesc: "Feminina, delicada",
        },
        aiModels: {
          gpt4oMiniDesc: "Recomendado - Equilíbrio entre velocidade e qualidade",
          gpt4oDesc: "Mais inteligente e detalhado",
          gpt41MiniDesc: "Rápido e eficiente",
          gpt41Desc: "Alta performance",
          gpt41NanoDesc: "Ultra rápido e econômico",
          o4MiniDesc: "Modelo de raciocínio avançado",
          geminiProDesc: "Google - Capacidade máxima",
          geminiFlashDesc: "Google - Rápido e econômico",
          claudeOpusDesc: "Anthropic - O mais inteligente, ideal para tarefas complexas",
          claudeSonnetDesc: "Anthropic - Equilíbrio entre qualidade e custo",
          claudeHaikuDesc: "Anthropic - Rápido e econômico",
          glmDesc: "Huawei Cloud - GLM, ótimo custo-benefício",
        },
        sectorRequired: "Selecione um setor de transferência",
      },
      prompts: {
        title: "Agente de IA",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          tokens_used: "Tokens Usados",
          actions: "Ações",
        },
        metrics: {
          title: "Métricas de Uso de Tokens",
          totalTokens: "Total de Tokens",
          inputTokens: "Tokens de Entrada",
          outputTokens: "Tokens de Saída",
          estimatedCost: "Custo Estimado (USD)",
          costTooltip: "Estimativa baseada nos preços médios do GPT-4o-mini. O custo real pode variar.",
          perAgent: "Consumo por Agente",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Agente",
        },
        noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
        totalContacts: "Total de Contatos",
        activeUsers: "Usuários Ativos",
        activeQueues: "Filas Ativas",
        withEmail: "Com E-mail",
        emptyTitle: "Nenhum contato na carteira",
        emptySubtitle: "Os contatos vinculados aparecerão aqui.",
        chartByUser: "Distribuição por Usuário",
        chartByQueue: "Contatos por Fila",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          aiAgent: "Agente de IA",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
           selectAiAgent: "Selecione um Agente de IA",
           selectModel: "Modelo de IA",
           addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showReturnQueueButton: "Mostrar botão de devolver para fila",
          showTransferTicketButton: "Mostrar botão de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automações",
          showSchedules: "Ver Agendamentos",
          showKanban: "Ver Kanban",
          showInternalChat: "Ver Chat Interno",
          showOpenAi: "Ver Agente de IA",
          showIntegrations: "Ver Integrações",
          finalizacaoComValorVenda: "Finalização com Valor de Venda",
          birthDate: "Data de Nascimento",
          birthDateHelper: "Data de nascimento para notificações de aniversário",
          connections: "Conexões",
          language: "Idioma",
          timezone: "Fuso horário (campanhas)",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        header: {
          title: "Conversas",
        },
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        elapsedPrefix: "há {{distance}}",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          myPlan: "Meu Plano",
          adminFinanceiro: "Gestão Financeira",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Agente de IA",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          automations: "Automações",
          groupManager: "Gestor de Grupos",
          n8nPanel: "Painel n8n",
          tasks: "Tarefas",
          followUp: "Follow UP (Templates)",
          salesPipeline: "Pipeline de Vendas",
          salesPipelineDesc: "Visualizar oportunidades",
          taskList: "Lista de Tarefas",
          taskListDesc: "Agendar e gerenciar",
          preferences: "Preferências",
          preferencesDesc: "Configurações do sistema",
          switchAccount: "Trocar de Conta",
          switchAccountDesc: "Gerenciar contas salvas",
        },
        planExpiresToday: "⚠️ Seu plano vence hoje! Renove agora para não perder o acesso.",
        planExpiresTomorrow: "⚠️ Seu plano vence amanhã! Renove para não perder o acesso.",
        planExpiresIn: "⏳ Seu plano vence em {{count}} dias. Renove para continuar usando o sistema.",
        renewNow: "Renovar agora",
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            switchAccount: "Trocar de Conta",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        title: "Notificações", clearAll: "Limpar tudo",
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          media: "Mídia",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        sortBy: "Ordenar por",
        startDate: "Data de início",
        endDate: "Data de fim",
        search: "Buscar",
        addColumns: "Adicionar colunas",
        allTickets: "Todos os tickets",
        myTickets: "Meus tickets",
        slaOverdue: "SLA Atrasado",
        filterSla: "Filtrar SLA",
        sortOptions: {
          ticketNumber: "Número do Ticket",
          lastMessage: "Última Mensagem",
          valueDesc: "Valor (maior para menor)",
        },
        toasts: {
          tagUpdated: "Ticket Tag atualizado com sucesso!",
          tagRemoved: "Ticket Tag removido!",
          adminOnly: "Apenas administradores podem reordenar as lanes do Kanban",
          laneOrderUpdated: "Ordem das lanes atualizada com sucesso",
          laneOrderError: "Erro ao salvar ordem das lanes",
        },
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
          recurrence: "Recorrência",
          nextExecution: "Próxima Execução",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        statuses: {
          inactive: "Inativa",
          scheduled: "Programada",
          inProgress: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        recurrence: {
          minutely: "Por Minuto",
          hourly: "Por Hora",
          daily: "Diário",
          weekly: "Semanal",
          biweekly: "Quinzenal",
          monthly: "Mensal",
          yearly: "Anual",
        },
        stopRecurrence: {
          title: "Interromper Recorrência",
          message: "Tem certeza que deseja interromper a recorrência desta campanha? A campanha atual continuará sendo executada, mas não haverão mais execuções futuras.",
        },
        filters: {
          status: "Status",
          all: "Todos",
          allFem: "Todas",
          recurrence: "Recorrência",
          recurring: "Recorrentes",
          single: "Única",
        },
        tooltips: {
          recurring: "Campanha Recorrente",
          stop: "Parar Campanha",
          restart: "Reiniciar Campanha",
          stopRecurrence: "Interromper Recorrência",
          duplicate: "Duplicar Campanha",
          export: "Exportar CSV",
          preview: "Pré-visualizar mensagem",
        },
        summary: {
          total: "Total",
          scheduled: "Programadas",
          inProgress: "Em Andamento",
          finished: "Finalizadas",
          cancelled: "Canceladas",
        },
        bulk: {
          selected: "selecionada(s)",
          cancelAll: "Cancelar",
          restartAll: "Reiniciar",
          deleteAll: "Excluir",
          confirmTitle: "Ação em Lote",
          confirmMessage: "Tem certeza que deseja executar esta ação em {{count}} campanha(s)?",
        },
        noMessage: "Sem mensagem",
        listRemoved: "Nenhuma lista vinculada",
        connectionDeleted: "Conexão excluída",
        connectionPrefix: "Conexão",
        noConnection: "Nenhuma conexão",
        notCompleted: "Não concluída",
        totalLabel: "campanhas",
        pagination: {
          rowsPerPage: "Linhas por página:",
          of: "de",
          moreThan: "mais de",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
          duplicated: "Campanha duplicada com sucesso!",
          bulkSuccess: "Ação em lote executada com sucesso!",
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
          recurrenceStopped: "Recorrência interrompida com sucesso!",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        fetchError: "Erro ao buscar dados do relatório",
        backButton: "Voltar",
        awaitingTemplateResponseCard: "Aguardando resposta do template",
        templateRespondedCard: "Responderam (follow-up enviado)",
        followUpStatus: {
          waiting: "Aguardando resposta",
          waitingTooltip: "Template enviado. Aguardando o cliente responder para liberar as mensagens 2-5 (janela de 24h da Meta).",
          sent: "Follow-ups enviados",
          sentTooltip: "Cliente respondeu ao template. As mensagens de follow-up (2-5) já foram enviadas.",
          expired: "Janela expirada",
          expiredTooltip: "A janela de 24h da Meta expirou sem resposta do cliente. As mensagens 2-5 não podem mais ser enviadas.",
        },
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          avatar: "Avatar",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
          backfillChats: "Gerar chats existentes",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          amount: "Valor",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openAi: "Agente de IA",
          integrations: "Integrações",
          flows: "Fluxos",
          contacts: "Contatos",
          dashboard: "Dashboard",
          realTime: "Tempo Real",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
        },
        confirmationModal: {
          deleteTitle: "Exclusão de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
        toasts: {
          success: "Operação realizada com sucesso!",
          errorList: "Não foi possível carregar a lista de registros",
          errorSave: "Não foi possível realizar a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente",
          errorDelete: "Não foi possível realizar a operação",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
        confirmationModal: {
          deleteTitle: "Exclusão de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
        toasts: {
          success: "Operação realizada com sucesso!",
          error: "Não foi possível realizar a operação",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        more: "mais",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuário",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
        tooltips: {
          bold: "Negrito",
          italic: "Itálico",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista Numerada",
          bulletList: "Lista com Marcadores",
          quote: "Citação",
          clearFormat: "Limpar Formatação",
          ghostMention: "Marcação Fantasma (notifica todos sem mostrar @)",
          triggerFlow: "Disparar Fluxo",
          aiSuggest: "IA: Sugerir Resposta",
          enableSignature: "Habilitar/Desabilitar Assinatura",
          enableComments: "Habilitar/Desabilitar Comentários",
        },
        menuItems: {
          ghostMention: "Marcação Fantasma",
          signature: "Assinatura",
          triggerFlow: "Disparar Fluxo",
          comments: "Comentários",
        },
        errors: {
          ticketIdNotFound: "Erro: ID do ticket não encontrado",
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
        aiSummarize: "Resumo IA do Atendimento",
        aiSummarizeTitle: "Resumo IA do Atendimento",
        aiSummaryCopied: "Resumo copiado para a área de transferência!",
        aiSummaryCopy: "Copiar",
        aiSummaryClose: "Fechar",
        aiSummarySaveNote: "Salvar como Nota",
        aiSummarySaved: "Resumo salvo como nota do contato!",
        autoAiSummary: "Auto-resumo IA ao finalizar",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        react: "Reagir",
        reactionSent: "Reação enviada",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_TICKET_NO_LINKED_CONNECTION:
          "Este ticket não possui conexão vinculada, provavelmente a conexão foi excluída.",
        ERR_PLAN_FEATURE_DISABLED: "Este recurso não está disponível no seu plano atual. Entre em contato com o administrador para fazer um upgrade.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        editMessage: "Editar Mensagem",
        messageLabel: "Mensagem",
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        logoMobile: "Logo Mobile (PWA)",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
      flowBuilder: {
        conversationFlows: "Fluxos de Conversa",
        addImage: {
          title: "Adicionar imagem ao fluxo",
          editTitle: "Editar imagem",
          add: "Adicionar",
          save: "Salvar",
          caption: "Legenda (opcional)",
          uploadImage: "Enviar imagem",
          successAdd: "Imagem adicionada com sucesso!",
          fileTooLarge: "Arquivo é muito grande! 2MB máximo",
          error: "erro",
        },
        addText: {
          title: "Adicionar mensagem ao fluxo",
          editTitle: "Editar mensagem ao fluxo",
          add: "Adicionar",
          save: "Salvar",
          message: "Mensagem",
        },
        addAttendant: {
          title: "Adicionar um atendente ao fluxo",
          editTitle: "Editar atendente",
          add: "Adicionar",
          edit: "Editar",
          chooseAttendant: "Escolha um atendente",
          selectUser: "Selecione um usuário",
          addAttendant: "Adicione um atendente",
        },
        condition: {
          title: "Nova Condição",
          editTitle: "Editar Condição",
          variableField: "Variável / Campo",
          variablePlaceholder: "Digite $ para ver variáveis disponíveis",
          variableHelper: "Digite $ para autocompletar variáveis do fluxo",
          conditionType: "Tipo de condição",
          comparisonValue: "Valor da comparação",
          commaSeparated: "Valores separados por vírgula",
          regexExample: "Ex: ^[0-9]{11}$ — expressão regular JavaScript",
          anyTokenTrigger: "Qualquer token da lista dispara Verdadeiro",
          fixedOrVariable: "Valor fixo ou variável com $",
          insertVariable: "Inserir variável pelo seletor",
          addCondition: "Adicionar condição",
          logicTrue: "Lógica: Verdadeiro se",
          allConditions: "TODAS as condições",
          anyCondition: "QUALQUER condição",
          satisfied: "forem satisfeitas",
          quickTips: "💡 Dicas rápidas",
          tipContainsAny: "Contém qualquer (,): separe tokens por vírgula →",
          tipRegex: "Regex: use expressão JS →",
          tipVariable: "Use ${variavel} em qualquer campo para referenciar valores dinâmicos",
          cancel: "Cancelar",
          saving: "Salvando...",
          saveChanges: "Salvar alterações",
          errorRequired: "o campo \"Variável / Campo\" é obrigatório",
          errorComparisonRequired: "o campo \"Valor da comparação\" é obrigatório",
          errorSave: "Ocorreu um erro ao salvar. Tente novamente.",
          selectVariable: "Selecionar variável",
          dynamicVarsFound: "variável(is) encontrada(s) no fluxo",
          addVarNodes: "Adicione nós de Variável Global ou Input para variáveis dinâmicas",
          searchVariable: "Buscar variável...",
          noVariableFound: "Nenhuma variável encontrada",
          flowVariables: "Variáveis do fluxo",
          // Operators
          equals: "Igual a",
          notEquals: "Diferente de",
          contains: "Contém texto",
          notContains: "Não contém",
          containsAny: "Contém qualquer (,)",
          startsWith: "Começa com",
          endsWith: "Termina com",
          greaterThan: "Maior que",
          lessThan: "Menor que",
          greaterOrEqual: "Maior ou igual a",
          lessOrEqual: "Menor ou igual a",
          isEmpty: "Está vazio",
          isNotEmpty: "Não está vazio",
          regex: "Expressão regular",
          // Groups
          equality: "Igualdade",
          text: "Texto",
          numeric: "Numérico",
          state: "Estado",
          advanced: "Avançado",
          // Static variables
          contactName: "Nome do contato",
          contactEmail: "Email do contato",
          contactPhone: "Telefone / número do contato",
          lastMessage: "Última mensagem recebida",
          ticketIdDesc: "ID do ticket atual",
          ticketStatusDesc: "Status do ticket (open/pending/closed)",
          ticketQueueDesc: "Fila atual do ticket",
          apiResponseDesc: "Resposta da última requisição HTTP",
          // Categories
          contact: "Contato",
          ticket: "Ticket",
          globalVariable: "Variável Global",
          capturedInput: "Input Capturado",
          menu: "Menu",
          httpApi: "HTTP / API",
          api: "API",
          // Dynamic descriptions
          globalVarDesc: "Variável global do fluxo",
          userResponseDesc: "Resposta capturada do usuário",
          responseFrom: "Resposta de:",
          menuResponse: "Resposta do menu:",
          menuOption: "Opção do menu:",
          mappedFrom: "Mapeado de:",
          httpVarDesc: "Variável da resposta HTTP",
          valuePrefix: "Valor:",
        },
      },
      flowBuilderTicketModal: {
        addTitle: "Adicionar Ticket",
        editTitle: "Editar Ticket",
        chooseQueue: "Escolher setor",
        selectConnection: "Selecione uma conexão",
        addQueueError: "Selecione um setor",
      },
      campaignModal: {
        // ===== Chaves planas usadas pelo CampaignModal (mescladas do bloco duplicado anterior) =====
        tabCampaign: "Campanha",
        tabContactLists: "📋 Listas de Contatos",
        tabSettings: "⚙️ Configurações",
        selectTemplateRequired: "Selecione um template aprovado para campanhas via API Oficial.",
        noTemplateFound: "Nenhum template aprovado encontrado. Crie um template antes de enviar.",
        templateRequired: "Obrigatório para API Oficial. Mensagens sem template falham fora da janela de 24h.",
        apiOfficialLabel: "API Oficial",
        recurrenceTitle: "Configuração de Recorrência",
        enableRecurrence: "Habilitar recorrência",
        recurrenceType: "Tipo de Recorrência",
        minutely: "Por Minuto",
        hourly: "Por Hora",
        daily: "Diário",
        weekly: "Semanal",
        biweekly: "Quinzenal",
        monthly: "Mensal",
        yearly: "Anual",
        interval: "Intervalo",
        everyInterval: "A cada {{count}} {{unit}}",
        minuteUnit: "minuto(s)",
        hourUnit: "hora(s)",
        dayUnit: "dia(s)",
        weekUnit: "semana(s)",
        biweekUnit: "quinzena(s)",
        monthUnit: "mês(es)",
        yearUnit: "ano(s)",
        daysOfWeek: "Dias da Semana",
        dayOfMonth: "Dia do Mês",
        dayOfMonthHelper: "Dia específico do mês (1-31)",
        endDate: "Data Final (opcional)",
        emptyRecurrence: "Deixe vazio para recorrência infinita",
        maxExecutions: "Máximo de Execuções (opcional)",
        hideExecutions: "Ocultar",
        showExecutions: "Visualizar",
        nextExecutions: "Próximas Execuções",
        next5Executions: "Próximas 5 Execuções:",
        nthExecution: "{{n}}ª Execução",
        campaignMessage: "Mensagem da Campanha",
        apiOfficialNote: "Para API Oficial, utilize o template selecionado ao lado. O campo de mensagem e anexo de mídia não estão disponíveis.",
        apiOfficialNoFollowUp: "⚠️ Follow-up disponível apenas para canais Baileys. Em campanhas via API Oficial, somente o template é enviado.",
        attachMedia: "Anexar Mídia",
        messageVariableHelper: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
        varName: "Nome",
        varNumber: "Número",
        varEmail: "Email",
        varGreeting: "Saudação",
        varProtocol: "Protocolo",
        varFirstName: "Primeiro Nome",
        varAgent: "Atendente",
        contactListTitle: "📋 Lista de Contatos da Campanha",
        contactListDesc: "Selecione uma lista criada na aba \"📋 Listas de Contatos\". A lista define quem receberá as mensagens desta campanha.",
        contactList: "Lista de Contatos",
        noListSelected: "Nenhuma lista selecionada",
        contacts: "contatos",
        filterByTag: "Filtrar por Tag (opcional)",
        noTagFilter: "Sem filtro de tag",
        switchList: "Trocar lista → Ir para Listas de Contatos",
        createOrSelectList: "+ Criar ou selecionar lista na aba Listas de Contatos",
        dispatchIntervals: "Intervalos de Disparo",
        dispatchIntervalsDesc: "Configure os intervalos de tempo entre os disparos desta campanha para evitar bloqueios.",
        antiBan: "Anti-Ban",
        antiBanDesc: "Humaniza o disparo para reduzir risco de bloqueio",
        jitterLabel: "Variação aleatória (jitter)",
        jitterFixed: "fixo",
        jitterMax: "máximo",
        jitterBase: "Base {{base}}s → entre {{min}}s e {{max}}s",
        jitterSelectBase: "⚠️ Selecione um intervalo base acima",
        extraPauseEvery: "Pausa extra a cada N msgs",
        disabled: "Desabilitado",
        everyNMessages: "A cada {{n}} mensagens",
        extraPauseDuration: "Duração da pausa extra",
        seconds: "segundos",
        minute1: "1 minuto",
        minutes2: "2 minutos",
        minutes5: "5 minutos",
        settingsSaved: "Configurações salvas com sucesso!",
        daysOfWeekOptions: {
          sunday: "Domingo",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
        },
        autoListName: "Campanha - {{name}} - {{date}}",
        noName: "Sem nome",
        // ===== Sub-objetos originais (validation, tabs, recurrence, etc) =====
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          recurrenceTypeRequired: "Tipo de recorrência é obrigatório",
          intervalMin: "Intervalo deve ser maior que 0",
          intervalRequired: "Intervalo é obrigatório",
          selectDay: "Selecione pelo menos um dia da semana",
          dayRange: "Dia deve ser entre 1 e 31",
          dayRequired: "Dia do mês é obrigatório",
          endDateFuture: "Data final deve ser futura",
          maxExecMin: "Número máximo deve ser maior que 0",
          noneValue: "Nenhuma",
        },
        tabs: {
          campaign: "Campanha",
          contactLists: "📋 Listas de Contatos",
          settings: "⚙️ Configurações",
        },
        recurrence: {
          title: "Configuração de Recorrência",
          enable: "Habilitar recorrência",
          type: "Tipo de Recorrência",
          interval: "Intervalo",
          dayOfMonth: "Dia do Mês",
          dayOfMonthHelper: "Dia específico do mês (1-31)",
          endDate: "Data Final (opcional)",
          endDateHelper: "Deixe vazio para recorrência infinita",
          maxExecutions: "Máximo de Execuções (opcional)",
          maxExecutionsHelper: "Deixe vazio para recorrência infinita",
          showExecutions: "Visualizar",
          hideExecutions: "Ocultar",
          nextExecutions: "Próximas Execuções",
          next5: "Próximas 5 Execuções:",
          nthExecution: "ª Execução",
          minutely: "A cada X minutos",
          hourly: "A cada X horas",
          daily: "Diária",
          weekly: "Semanal",
          biweekly: "Quinzenal",
          monthly: "Mensal",
          yearly: "Anual",
        },
        days: {
          sunday: "Domingo",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
        },
        message: {
          title: "Mensagem da Campanha",
          variables: {
            name: "Nome",
            number: "Número",
            email: "Email",
            greeting: "Saudação",
            protocol: "Protocolo",
            firstName: "Primeiro Nome",
            attendant: "Atendente",
          },
          helperText: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          oficialNotAvailable: "Para API Oficial, utilize o template selecionado ao lado. O campo de mensagem e anexo de mídia não estão disponíveis.",
          attachMedia: "Anexar Mídia",
          preview: "Preview",
        },
        template: {
          label: "Template *",
          noTemplates: "Nenhum template aprovado encontrado. Crie um template antes de enviar.",
          helperText: "Obrigatório para API Oficial. Mensagens sem template falham fora da janela de 24h.",
          selectTemplate: "Selecione um template aprovado para campanhas via API Oficial.",
        },
        contactListGroup: {
          title: "📋 Lista de Contatos da Campanha",
          description: "Selecione uma lista criada na aba \"📋 Listas de Contatos\". A lista define quem receberá as mensagens desta campanha.",
          label: "Lista de Contatos",
          noList: "Nenhuma lista selecionada",
          contacts: "contatos",
          filterByTag: "Filtrar por Tag (opcional)",
          noTagFilter: "Sem filtro de tag",
          switchList: "Trocar lista → Ir para Listas de Contatos",
          createOrSelect: "+ Criar ou selecionar lista na aba Listas de Contatos",
        },
        triggerSettings: {
          title: "Intervalos de Disparo",
          description: "Configure os intervalos de tempo entre os disparos desta campanha para evitar bloqueios.",
          antiBan: "Anti-Ban",
          antiBanDesc: "Humaniza o disparo para reduzir risco de bloqueio",
          jitterLabel: "Variação aleatória (jitter)",
          jitterFixed: "fixo",
          jitterMax: "máximo",
          jitterBase: "Base",
          jitterBetween: "entre",
          jitterAnd: "e",
          selectBaseInterval: "⚠️ Selecione um intervalo base acima",
          extraPause: "Pausa extra a cada N msgs",
          extraPauseDuration: "Duração da pausa extra",
          disabled: "Desabilitado",
          every10: "A cada 10 mensagens",
          every20: "A cada 20 mensagens",
          every30: "A cada 30 mensagens",
          every50: "A cada 50 mensagens",
          every100: "A cada 100 mensagens",
          seconds: "segundos",
          minute1: "1 minuto",
          minutes2: "2 minutos",
          minutes5: "5 minutos",
          savedSuccess: "Configurações salvas com sucesso!",
          saveSettings: "Salvar Configurações",
        },
        followUp: {
          toggle: "Enviar mensagem após template",
          delayLabel: "Delay entre mensagens",
          description: "Mensagens enviadas em sequência após o template (dentro da janela de 24h).",
          multipleHelp: "Preencha apenas as mensagens que deseja enviar. Serão enviadas em sequência. Mídia é enviada na 1ª mensagem.",
          windowWarningTitle: "Janela de 24h da Meta",
          windowWarningBody: "As mensagens 2 a 5 só serão enviadas APÓS o cliente responder ao template. A API Oficial do WhatsApp exige que o destinatário responda para abrir uma janela de 24h. Se o cliente não responder, apenas o template será entregue.",
          delay3s: "3 segundos",
          delay5s: "5 segundos",
          delay10s: "10 segundos",
          delay30s: "30 segundos",
          delay60s: "1 minuto",
          useApprovedTemplate: "Usar template aprovado",
          noSimpleTemplate: "Nenhum template simples disponível",
          selectApprovedTemplate: "Selecione um template aprovado",
          simpleTemplateHelper: "Apenas templates aprovados sem variáveis aparecem aqui. A mídia do header (se houver) faz parte do template.",
          metaRestrictionTitle: "Restrição da Meta — janela de 24h",
          metaRestrictionBody: "Você preencheu mensagens adicionais (2-5) em uma campanha API Oficial. A Meta só permite o envio dessas mensagens após o cliente responder ao template inicial, e dentro de uma janela de 24h.",
          metaRestrictionEnableHint: "Ative o switch \"Enviar mensagem após template\" abaixo, caso contrário as mensagens 2-5 não serão enviadas.",
        },
      },
      chatMessages: {
        user: "Usuário",
        today: "HOJE",
        loadingOldMessages: "Carregando mensagens antigas...",
        viewDocument: "Visualizar Documento",
        doubleClickReply: "Clique duas vezes para responder",
        messageLabel: "Mensagem",
        messageNotFound: "[mensagem não encontrada]",
      },
      finalizacaoAtendimento: {
        title: "Finalização de Atendimento",
        generalSettings: "Configurações Gerais",
        informSaleValue: "Informar valor da venda ao finalizar atendimento",
        informSaleValueHelper: "Quando habilitado, o campo de valor da venda aparecerá no modal de finalização",
        finalizationReasons: "Motivos de Finalização",
        addReason: "Adicionar Motivo",
        name: "Nome",
        description: "Descrição",
        actions: "Ações",
        noDescription: "Sem descrição",
        noReasons: "Nenhum motivo cadastrado. Clique em \"Adicionar Motivo\" para começar.",
        editReason: "Editar Motivo",
        reasonName: "Nome do Motivo",
        descriptionOptional: "Descrição (opcional)",
        cancel: "Cancelar",
        saving: "Salvando...",
        update: "Atualizar",
        add: "Adicionar",
        nameRequired: "Nome do motivo é obrigatório",
        reasonUpdated: "Motivo atualizado com sucesso!",
        reasonCreated: "Motivo criado com sucesso!",
        reasonSaveError: "Erro ao salvar motivo",
        confirmDelete: "Tem certeza que deseja excluir este motivo?",
        reasonDeleted: "Motivo excluído com sucesso!",
        reasonDeleteError: "Erro ao excluir motivo",
        settingUpdated: "Configuração atualizada com sucesso!",
        settingUpdateError: "Erro ao atualizar configuração",
        currencyUpdated: "Moeda atualizada com sucesso!",
        currencyUpdateError: "Erro ao atualizar moeda",
      },
      interactiveMessage: {
        tabs: {
          buttons: "Botões",
          list: "Lista",
          billing: "Cobrança",
          offers: "Ofertas",
          pix: "PIX",
          url: "URL",
          call: "Ligação",
          location: "Local",
          carousel: "Carrossel",
          catalog: "Catálogo",
          poll: "Enquete",
        },
        select: "Selecionar",
        options: "Opções",
        reviewAndPay: "Revisar e pagar",
        templateLoaded: "Template \"{{name}}\" carregado",
        templateNameRequired: "Digite um nome para o template",
        templateSaved: "Template salvo!",
        templateSaveError: "Erro ao salvar template",
        templateRemoved: "Template removido",
        templateRemoveError: "Erro ao remover",
        fillMessageText: "Preencha o texto da mensagem",
        addAtLeastOneButton: "Adicione pelo menos um botão",
        addAtLeastOneListOption: "Adicione pelo menos uma opção na lista",
        fillLatLong: "Preencha latitude e longitude",
        fillUrl: "Preencha a URL",
        fillPhone: "Preencha o número de telefone",
        fillPixKey: "Preencha a chave PIX",
        addAtLeast2Options: "Adicione pelo menos 2 opções",
        addAtLeastOneCard: "Adicione pelo menos um card",
        fillBillingDescription: "Preencha a descrição da cobrança",
        pdfUploadError: "Erro ao enviar PDF",
        messageSent: "Mensagem interativa enviada!",
        sendError: "Erro ao enviar",
        buttonsInfo: "Envie até 3 botões clicáveis. O cliente pode tocar em um botão para responder rapidamente.",
        messageText: "Texto da mensagem *",
        footerOptional: "Rodapé (opcional)",
        buttonsMax3: "Botões (máx. 3)",
        addButton: "Adicionar",
        optionPlaceholder: "Opção {{number}}",
        listInfo: "Envie uma lista com até 10 opções. O cliente abre um menu para selecionar.",
        buttonText: "Texto do botão",
        sectionTitle: "Título da seção",
        titleLabel: "Título",
        descriptionLabel: "Descrição",
        addOption: "Adicionar opção",
        offerInfo: "Envie uma oferta com título, preço e descrição.",
        offerTitle: "Título da oferta",
        bodyDescription: "Descrição / Corpo da mensagem *",
        price: "Preço (ex: 99,90)",
        additionalDetails: "Detalhes adicionais",
        pixInfo: "Envie dados PIX formatados para o cliente.",
        pixKey: "Chave PIX *",
        pixKeyPlaceholder: "CPF, CNPJ, e-mail, telefone ou chave aleatória",
        beneficiaryName: "Nome do beneficiário",
        city: "Cidade",
        amount: "Valor",
        urlInfo: "Envie um link clicável com texto personalizado.",
        linkText: "Texto do link",
        linkTextPlaceholder: "Clique aqui",
        urlLabel: "URL *",
        urlPlaceholder: "https://...",
        callInfo: "Envie uma mensagem com número para ligação.",
        callButtonText: "Texto do botão",
        callButtonPlaceholder: "Ligar agora",
        phoneNumber: "Número de telefone *",
        locationInfo: "Envie uma localização para o cliente.",
        locationName: "Nome do local",
        address: "Endereço",
        latitude: "Latitude *",
        longitude: "Longitude *",
        carouselInfo: "Envie múltiplos cards como carrossel.",
        cardLabel: "Card {{number}}",
        addCard: "Adicionar card",
        catalogInfo: "Envie produtos do catálogo como cards.",
        productLabel: "Produto {{number}}",
        productName: "Nome do produto",
        priceDescription: "Descrição / Preço",
        addProduct: "Adicionar produto",
        pollInfo: "Crie uma enquete para o cliente votar.",
        pollQuestion: "Pergunta da enquete *",
        pollOptionsLabel: "Opções (mín. 2, máx. 12)",
        billingInfo: "Envie uma cobrança com detalhes do pagamento e botão \"Revisar e pagar\".",
        billingNumber: "Nº da cobrança",
        billingDescription: "Descrição da cobrança *",
        quantity: "Quantidade",
        totalAmount: "Valor total",
        billingMessage: "Mensagem adicional",
        paymentUrl: "URL de pagamento (opcional)",
        paymentButtonText: "Texto do botão de pagamento",
        attachPdf: "Anexar PDF (boleto)",
        save: "Salvar",
        cancel: "Cancelar",
        send: "Enviar",
        sending: "Enviando...",
        saveTemplate: "Salvar como template",
        templateNameLabel: "Nome do template",
        saveTemplateBtn: "Salvar Template",
        noTemplates: "Nenhum template salvo",
        templates: "Templates",
        deleteTemplate: "Excluir template",
      },
      flowBuilderInteractive: {
        title: "Mensagem Interativa (Baileys)",
        editTitle: "Editar Mensagem Interativa",
        add: "Adicionar",
        save: "Salvar",
        cancel: "Cancelar",
        messageType: "Tipo de mensagem interativa",
        buttonsMax3: "Botões (máx. 3)",
        infoText: "Botões interativos via Baileys (nativeFlowMessage). Funciona em conexões não-oficiais. Limite de 3 botões.",
        messageContent: "CONTEÚDO DA MENSAGEM",
        buttonsTab: "BOTÕES",
        messageBody: "Corpo da mensagem",
        footerOptional: "Rodapé (opcional)",
        headerImageOptional: "Imagem de cabeçalho (opcional)",
        changeImage: "Trocar imagem",
        uploadImage: "Enviar imagem",
        listButtonText: "Texto do botão da lista",
        listButtonHelper: "Texto exibido no botão que abre a lista",
        preview: "Pré-visualização",
        messageBodyPlaceholder: "Corpo da mensagem...",
        buttonsLabel: "Botões",
        listOptions: "Opções da lista",
        buttonTextPlaceholder: "Texto do botão {{number}}",
        optionPlaceholder: "Opção {{number}}",
        addAtLeastOneOption: "Adicione pelo menos uma opção.",
        bodyRequired: "O corpo da mensagem é obrigatório!",
        addOption: "Adicione pelo menos uma opção!",
        fileTooLarge: "Arquivo muito grande! Máximo 2MB",
        imageUploadError: "Erro ao enviar imagem",
        maxOptionsReached: "Limite máximo de {{max}} opções para botões!",
      },
      flowBuilderVideo: {
        title: "Adicionar video ao fluxo",
        editTitle: "Editar video",
        add: "Adicionar",
        save: "Salvar",
        captionOptional: "Legenda (opcional)",
        uploadVideo: "Enviar video",
        mp4Only: "ATENÇÃO! Apenas videos em MP4!",
        videoAdded: "Video adicionado com sucesso!",
        fileTooLarge: "Arquivo é muito grande! 20MB máximo",
        browserNotSupported: "seu navegador não suporta HTML5",
      },
      flowBuilderInput: {
        addTitle: "Adicionar input ao fluxo",
        title: "Adicionar input ao fluxo",
        editTitle: "Editar input do fluxo",
        add: "Adicionar",
        saveChanges: "Salvar alterações",
        question: "Pergunta",
        questionTooltip: "A pergunta que será enviada ao usuário. Você pode incluir variáveis usando $\\{nomeVariavel}",
        questionLabel: "Digite a pergunta",
        typeQuestion: "Digite a pergunta",
        questionPlaceholder: "Ex: Olá {{firstName}}, qual é a sua idade?",
        flowVariables: "Variáveis de fluxo (clique para inserir):",
        variableName: "Nome da variável",
        variableNameTooltip: "Nome da variável onde a resposta será armazenada. Não use espaços ou caracteres especiais.",
        variableTooltip: "Nome da variável onde a resposta será armazenada. Não use espaços ou caracteres especiais.",
        variableNameLabel: "Nome da variável",
        variableNamePlaceholder: "Ex: idade_cliente",
        variablePlaceholder: "Ex: idade_cliente",
        variableNameHelper: "A resposta do usuário será armazenada nesta variável",
        variableHelper: "A resposta do usuário será armazenada nesta variável",
        howItWorks: "Como funciona",
        howItWorksDescription: "Este nó enviará a pergunta ao usuário e aguardará uma resposta. Quando o usuário responder, o valor será armazenado na variável especificada e o fluxo continuará para o próximo nó.",
        howItWorksDesc: "Este nó enviará a pergunta ao usuário e aguardará uma resposta. Quando o usuário responder, o valor será armazenado na variável especificada e o fluxo continuará para o próximo nó.",
        examples: {
          name: "Nome do cliente",
          email: "Email do cliente",
          phone: "Telefone do cliente",
          city: "Cidade do cliente",
        },
        exampleVars: {
          nome: "Nome do cliente",
          email: "Email do cliente",
          telefone: "Telefone do cliente",
          cidade: "Cidade do cliente",
        },
      },
      flowBuilderTag: {
        addTitle: "Adicionar uma tag ao fluxo",
        editTitle: "Editar tag",
        chooseTag: "Escolha uma tag",
        selectTag: "Selecione uma tag",
        noTagSelected: "Nenhuma tag selecionada",
        addTag: "Adicione uma tag",
        add: "Adicionar",
        edit: "Editar",
      },
      flowBuilderSingleBlock: {
        addTitle: "Adicionar conteúdo ao fluxo",
        editTitle: "Editar conteúdo",
        addMenu: "Adicionar menu ao fluxo",
        add: "Adicionar",
        save: "Salvar",
        image: "Imagem",
        uploadImage: "Enviar imagem",
        captionOptional: "Legenda (opcional)",
        audio: "Audio",
        uploadAudio: "Enviar audio",
        sendAsRecorded: "Enviar como audio gravado na hora",
        video: "Video",
        uploadVideo: "Enviar video",
        text: "Texto",
        message: "Mensagem",
        interval: "Intervalo",
        timeInSeconds: "Tempo em segundos",
        document: "Documento",
        uploadDocument: "Enviar Documento",
        viewDocument: "Visualizar Documento",
        contentAdded: "Conteúdo adicionada com sucesso!",
        deleteEmptyCards: "Delete os cards vazios(Imagem, Audio e Video)",
        emptyMessageFields: "Campos de mensagem vazio!",
        intervalInvalid: "Intervalo não pode ser 0 ou maior que 120!",
        fileTooLargeImg: "Arquivo é muito grande! 2MB máximo",
        fileTooLargeAudio: "Arquivo é muito grande! 5MB máximo",
        fileTooLargeVideo: "Arquivo é muito grande! 20MB máximo",
        fileTooLargeDoc: "Arquivo é muito grande! 10MB máximo",
        browserNotSupported: "seu navegador não suporta HTML5",
        variableLabels: {
          firstName: "Primeiro Nome",
          name: "Nome",
          userName: "Atendente",
          ms: "Saudação",
          protocol: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          phoneNumber: "Telefone",
          email: "E-mail",
          kanban: "Kanban",
        },
      },
      flowBuilderGemini: {
        title: "Adicionar Gemini ao fluxo",
        editTitle: "Editar Gemini do fluxo",
        add: "Adicionar",
        save: "Salvar",
        cancel: "Cancelar",
        basicSettings: "Configurações Básicas - Google Gemini",
        assistantName: "Nome do Assistente",
        apiKey: "API Key Google AI",
        model: "Modelo Gemini",
        systemPrompt: "Prompt do Sistema",
        systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
        temperature: "Temperatura",
        temperatureHelper: "0 = conservador, 2 = criativo",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Tamanho máximo da resposta",
        maxMessages: "Max Mensagens",
        maxMessagesHelper: "Histórico de contexto",
        flowBehavior: "Comportamento do Fluxo",
        flowBehaviorTooltip: "Configure como o Gemini deve se comportar no fluxo",
        operationMode: "Modo de Funcionamento",
        permanent: "Permanente",
        permanentDesc: "Encerrar fluxo aqui",
        permanentHelper: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
        temporary: "Temporário",
        temporaryDesc: "Volta ao fluxo depois",
        temporaryHelper: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
        temporarySettings: "Configurações do Modo Temporário",
        temporarySettingsDesc: "Configure quando a IA deve parar e retornar ao fluxo",
        maxInteractions: "Máximo de Interações",
        maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
        timeout: "Timeout (minutos)",
        timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
        continueKeywords: "Palavras-chave para Continuar Fluxo",
        keywordPlaceholder: "Digite uma palavra-chave",
        addKeyword: "Adicionar",
        keywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
        objective: "Objetivo da IA",
        objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
        objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
        autoComplete: "Auto completar quando atingir objetivo",
        autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          describeTraining: "Descreva o treinamento para Inteligência Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informe o modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 8000 tokens",
          informMaxTokens: "Informe o número máximo de tokens",
          minTemp: "Mínimo 0",
          maxTemp: "Máximo 2",
          informTemp: "Informe a temperatura",
          informApiKey: "Informe a API Key",
          minMessages: "Mínimo 1 mensagem",
          maxMessages: "Máximo 100 mensagens",
          informMaxMessages: "Informe o número máximo de mensagens",
          invalidFlowMode: "Modo de fluxo inválido",
          selectFlowMode: "Selecione o modo de fluxo",
          minInteraction: "Mínimo 1 interação",
          maxInteraction: "Máximo 50 interações",
          minTimeout: "Mínimo 1 minuto",
          maxTimeout: "Máximo 60 minutos",
          keywordRequired: "Palavra-chave não pode estar vazia",
          atLeastOneKeyword: "Pelo menos uma palavra-chave é obrigatória no modo temporário",
          objectiveRequired: "Objetivo é obrigatório quando auto completar está ativo",
        },
      },
      flowBuilderOpenAI: {
        title: "Adicionar OpenAI ao fluxo",
        editTitle: "Editar OpenAI do fluxo",
        add: "Adicionar",
        save: "Salvar",
        cancel: "Cancelar",
        basicSettings: "Configurações Básicas - OpenAI",
        assistantName: "Nome do Assistente",
        apiKey: "API Key OpenAI",
        model: "Modelo OpenAI",
        systemPrompt: "Prompt do Sistema",
        systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
        temperature: "Temperatura",
        temperatureHelper: "0 = conservador, 2 = criativo",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Tamanho máximo da resposta",
        maxMessages: "Max Mensagens",
        maxMessagesHelper: "Histórico de contexto",
        voiceSettings: "Configurações de Voz (Opcional)",
        responseType: "Tipo de Resposta",
        textOnly: "Apenas Texto",
        voiceKeyLabel: "Voice Key (Azure)",
        voiceKeyPlaceholder: "Chave do Azure Speech Service",
        voiceRegionLabel: "Voice Region (Azure)",
        voiceRegionPlaceholder: "ex: brazilsouth",
        flowBehavior: "Comportamento do Fluxo",
        flowBehaviorTooltip: "Configure como o OpenAI deve se comportar no fluxo",
        operationMode: "Modo de Funcionamento",
        permanent: "Permanente",
        permanentDesc: "Encerrar fluxo aqui",
        permanentHelper: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
        temporary: "Temporário",
        temporaryDesc: "Volta ao fluxo depois",
        temporaryHelper: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
        temporarySettings: "Configurações do Modo Temporário",
        temporarySettingsDesc: "Configure quando a IA deve parar e retornar ao fluxo",
        maxInteractions: "Máximo de Interações",
        maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
        timeout: "Timeout (minutos)",
        timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
        continueKeywords: "Palavras-chave para Continuar Fluxo",
        keywordPlaceholder: "Digite uma palavra-chave",
        addKeyword: "Adicionar",
        keywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
        objective: "Objetivo da IA",
        objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
        objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
        autoComplete: "Auto completar quando atingir objetivo",
        autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          describeTraining: "Descreva o treinamento para Inteligência Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informe o modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4000 tokens",
          informMaxTokens: "Informe o número máximo de tokens",
          minTemp: "Mínimo 0",
          maxTemp: "Máximo 2",
          informTemp: "Informe a temperatura",
          informApiKey: "Informe a API Key",
          minMessages: "Mínimo 1 mensagem",
          maxMessages: "Máximo 100 mensagens",
          informMaxMessages: "Informe o número máximo de mensagens",
          informVoice: "Informe o modo para Voz",
          voiceKeyRequired: "Voice Key é obrigatória para síntese de voz",
          voiceRegionRequired: "Voice Region é obrigatória para síntese de voz",
          invalidFlowMode: "Modo de fluxo inválido",
          selectFlowMode: "Selecione o modo de fluxo",
          minInteraction: "Mínimo 1 interação",
          maxInteraction: "Máximo 50 interações",
          minTimeout: "Mínimo 1 minuto",
          maxTimeout: "Máximo 60 minutos",
          keywordRequired: "Palavra-chave não pode estar vazia",
          atLeastOneKeyword: "Pelo menos uma palavra-chave é obrigatória no modo temporário",
          objectiveRequired: "Objetivo é obrigatório quando auto completar está ativo",
        },
      },
      validation: {
        tooShort: "Muito curto!",
        tooLong: "Muito longo!",
        required: "Obrigatório",
        messageTooShort: "Mensagem muito curta",
        nameTooShort: "nome muito curto",
      },
    embeddedSignup: {
      title: "WhatsApp Embedded Signup",
      subtitle: "Cadastre seu número diretamente pelo CRM",
      steps: { configure: "Configurar", processing: "Processando", result: "Resultado" },
      description: "Clique no botão abaixo para iniciar o processo de cadastro do seu número WhatsApp Business diretamente pela Meta.",
      connectionName: "Nome da conexão",
      connectionNamePlaceholder: "Ex: WhatsApp Principal",
      infoTitle: "O que acontece:",
      infoItems: { popup: "Um popup da Meta será aberto", login: "Você fará login com sua conta do Facebook Business", select: "Selecionará ou criará uma conta WhatsApp Business", register: "O número será registrado automaticamente no CRM" },
      buttons: { loadingSdk: "Carregando SDK...", processing: "Processando...", start: "Iniciar Cadastro via Meta", close: "Fechar", cancel: "Cancelar" },
      success: { title: "Conexão criada com sucesso!", name: "Nome", number: "Número", numberPending: "Será exibido em breve", wabaId: "WABA ID", status: "Status" },
      errors: { title: "Erro no cadastro", noAppId: "App ID da Meta não configurado!", noConfigId: "Configuration ID da Meta não configurado!", noName: "Informe um nome para a conexão!", sdkNotLoaded: "SDK da Meta não carregou corretamente. Recarregue a página e tente novamente.", sdkInitFailed: "Falha ao inicializar o SDK da Meta.", sdkLoadFailed: "Falha ao carregar o SDK da Meta. Desative bloqueadores e permita popups.", sdkNotAvailable: "SDK do Facebook não ficou disponível no navegador.", appIdNotConfigured: "App ID da Meta não configurado! Vá em Configurações > Integrações Meta.", configIdNotConfigured: "Configuration ID da Meta não configurado! Vá em Configurações > Integrações Meta.", timeout: "Tempo esgotado. O popup da Meta pode ter sido bloqueado pelo navegador. Permita popups e tente novamente.", noAuthCode: "Código de autorização não recebido. Verifique as permissões do app.", cancelled: "Processo cancelado pelo usuário.", signupError: "Erro durante o processo de cadastro.", processingError: "Erro ao processar o cadastro. Tente novamente.", popupError: "Erro ao abrir popup da Meta. Verifique se popups estão permitidos.", loginCancelled: "Login cancelado ou não autorizado.", metaStatus: "Meta retornou status:" },
      processing: { title: "Processando cadastro...", description: "Estamos trocando as credenciais com a Meta e configurando sua conexão." },
      menuItem: "WhatsApp Embedded Signup",
    },
    },
    flowBuilderConditionModal: {
      addTitle: "Adicionar condição ao fluxo",
      editTitle: "Editar condição",
      add: "Adicionar",
      save: "Salvar",
      conditionField: "Campo da condição (Digiter apenas 1 chave)",
      validationRule: "Regra de validação",
      conditionValue: "Valor da condição a ser analisada",
    },
    flowBuilderTypebot: {
      addTitle: "Adicionar Typebot ao fluxo",
      editTitle: "Editar Typebot ao fluxo",
      add: "Adicionar",
      edit: "Editar",
      save: "Salvar",
    },
    flowBuilderSwitchFlow: {
      addTitle: "Adicionar Troca de Fluxo",
      editTitle: "Editar Troca de Fluxo",
      add: "Adicionar",
      edit: "Editar",
      save: "Salvar",
      chooseFlow: "Escolha um fluxo",
    },
    flowBuilderRandomizer: {
      add: "Adicionar",
      edit: "Editar",
    },
    flowBuilderRandomizerModal: {
      addTitle: "Adicionar randomizador ao fluxo",
      editTitle: "Editar randomizador",
      addIntervalError: "O percentual deve ser maior que 0",
      maxTimeError: "O percentual não pode ser maior que 120",
    },
    flowBuilderMenu: {
      addTitle: "Adicionar menu ao fluxo",
      editTitle: "Editar menu do fluxo",
      add: "Adicionar",
      save: "Salvar",
      menuMessage: "Mensagem do menu",
      addOption: "Adicionar opção",
      digit: "Dígito",
      typeOption: "Digite a opção",
    },
    flowBuilderInterval: {
      addTitle: "Adicionar intervalo ao fluxo",
      editTitle: "Editar intervalo",
      add: "Adicionar",
      edit: "Editar",
      timeInSeconds: "Tempo em segundos",
      addIntervalError: "O intervalo deve ser maior que 0",
      maxTimeError: "O intervalo não pode ser maior que 120",
    },
    flowBuilderRemoveTag: {
      addTitle: "Remover uma tag do fluxo",
      editTitle: "Editar remoção de tag",
      addRemoval: "Adicionar Remoção",
      edit: "Editar",
      selectTagToRemove: "Selecione uma tag para remover",
      noTagSelected: "Nenhuma tag selecionada",
      chooseTag: "Escolha uma tag para remover do contato",
      actionDescription: "Esta ação removerá a tag selecionada do contato quando o fluxo for executado",
      selectTagError: "Selecione uma tag para remover",
      title: "Remover Tag",
      tagNotSelected: "Tag não selecionada",
      removesTagFromContact: "Remove a tag do contato",
    },
    flowBuilderTicket: {
      add: "Adicionar",
      edit: "Editar",
    },
    flowBuilderVideo: {
      addTitle: "Adicionar video ao fluxo",
      editTitle: "Editar video",
      add: "Adicionar",
      save: "Salvar",
    },
    flowBuilderAudio: {
      addTitle: "Adicionar audio ao fluxo",
      editTitle: "Editar audio",
      add: "Adicionar",
      save: "Salvar",
    },
    flowBuilderGeminiModal: {
      addTitle: "Adicionar Gemini ao fluxo",
      editTitle: "Editar Gemini do fluxo",
      add: "Adicionar",
      save: "Salvar",
      cancel: "Cancelar",
      basicSettings: "Configurações Básicas - Google Gemini",
      assistantName: "Nome do Assistente",
      geminiModel: "Modelo Gemini",
      systemPrompt: "Prompt do Sistema",
      systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
      temperature: "Temperatura",
      temperatureHelper: "0 = conservador, 2 = criativo",
      maxTokensLabel: "Max Tokens",
      maxTokensHelper: "Tamanho máximo da resposta",
      maxMessagesLabel: "Max Mensagens",
      maxMessagesHelper: "Histórico de contexto",
      flowBehavior: "Comportamento do Fluxo",
      flowBehaviorTooltip: "Configure como o Gemini deve se comportar no fluxo",
      operationMode: "Modo de Funcionamento",
      permanent: "Permanente",
      permanentDesc: "Encerrar fluxo aqui",
      permanentHelper: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
      temporary: "Temporário",
      temporaryDesc: "Volta ao fluxo depois",
      temporaryHelper: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
      temporarySettings: "Configurações do Modo Temporário",
      temporarySettingsDesc: "Configure quando a IA deve parar e retornar ao fluxo",
      maxInteractions: "Máximo de Interações",
      maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
      timeoutLabel: "Timeout (minutos)",
      timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
      continueKeywords: "Palavras-chave para Continuar Fluxo",
      keywordPlaceholder: "Digite uma palavra-chave",
      addKeyword: "Adicionar",
      keywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
      objectiveLabel: "Objetivo da IA",
      objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
      objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
      autoComplete: "Auto completar quando atingir objetivo",
      autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
      queueId: "ID da Fila (para transferência)",
      queueIdHelper: "ID da fila para onde transferir se usuário pedir atendente (0 = não transferir)",
    },
    interactiveMessageModal: {
      title: "Enviar Mensagem Interativa",
      subtitle: "Envie mensagens com botões, listas, ofertas, PIX ou links",
      templateActive: "📋 Template: {{name}}",
      cancel: "Cancelar",
      send: "Enviar",
      sending: "Enviando...",
      save: "Salvar",
      saveTemplate: "Salvar Template",
      saveAsTemplate: "Salvar como template",
      loadTemplate: "Carregar template salvo",
      models: "Modelos",
      templateNameLabel: "Nome do template",
      templateNamePlaceholder: "Ex: Boas-vindas com botões",
      saveCurrentConfig: "Salve a configuração atual como um modelo reutilizável para o tipo",
      noTemplates: "Nenhum template salvo para este tipo",
      templateLoaded: "Template \"{{name}}\" carregado",
      templateSaved: "Template salvo!",
      templateRemoved: "Template removido",
      templateSaveError: "Erro ao salvar template",
      templateRemoveError: "Erro ao remover",
      templateNameRequired: "Digite um nome para o template",
      messageSent: "Mensagem interativa enviada!",
      messageError: "Erro ao enviar",
      fillMessageText: "Preencha o texto da mensagem",
      addAtLeastOneButton: "Adicione pelo menos um botão",
      addAtLeastOneOption: "Adicione pelo menos uma opção na lista",
      fillLatLong: "Preencha latitude e longitude",
      fillUrl: "Preencha a URL",
      fillPhone: "Preencha o número de telefone",
      fillPixKey: "Preencha a chave PIX",
      addAtLeast2Options: "Adicione pelo menos 2 opções",
      addAtLeastOneCard: "Adicione pelo menos um card",
      fillBillingDesc: "Preencha a descrição da cobrança",
      pdfUploadError: "Erro ao enviar PDF",
      pdfTooBig: "PDF muito grande (máx. 16MB)",
      previewTitle: "Preview da Mensagem",
      billingDesc: "Descrição da cobrança...",
      messageBody: "Corpo da mensagem...",
      tabs: {
        buttons: "Botões",
        list: "Lista",
        billing: "Cobrança",
        offers: "Ofertas",
        pix: "PIX",
        url: "URL",
        call: "Ligação",
        location: "Local",
        carousel: "Carrossel",
        catalog: "Catálogo",
        poll: "Enquete",
      },
      buttonsTab: {
        info: "Envie até 3 botões clicáveis. O cliente pode tocar em um botão para responder rapidamente.",
        messageText: "Texto da mensagem *",
        footer: "Rodapé (opcional)",
        buttonsMax: "Botões (máx. 3)",
        add: "Adicionar",
        option: "Opção",
      },
      listTab: {
        info: "Envie uma lista com até 10 opções. O cliente abre um menu para selecionar.",
        messageText: "Texto da mensagem *",
        footer: "Rodapé (opcional)",
        buttonText: "Texto do botão",
        sectionTitle: "Título da seção",
        title: "Título",
        description: "Descrição",
        addOption: "Adicionar opção",
        select: "Selecionar",
      },
      offerTab: {
        info: "🏷️ Envie uma oferta com título, preço e descrição.",
        offerTitle: "Título da oferta",
        bodyText: "Descrição / Corpo da mensagem *",
        price: "Preço (ex: 99,90)",
        additionalDetails: "Detalhes adicionais",
        footer: "Rodapé (opcional)",
      },
      pixTab: {
        info: "💰 Envie dados PIX formatados para o cliente.",
        messageText: "Texto da mensagem *",
        pixKey: "Chave PIX *",
        pixKeyPlaceholder: "CPF, CNPJ, e-mail, telefone ou chave aleatória",
        beneficiaryName: "Nome do beneficiário",
        city: "Cidade",
        amount: "Valor",
      },
      urlTab: {
        info: "🔗 Envie um link clicável com texto personalizado.",
        messageText: "Texto da mensagem *",
        linkText: "Texto do link",
        linkPlaceholder: "Clique aqui",
        url: "URL *",
        footer: "Rodapé (opcional)",
      },
      callTab: {
        info: "📞 Envie uma mensagem com número para ligação.",
        messageText: "Texto da mensagem *",
        buttonText: "Texto do botão",
        buttonPlaceholder: "Ligar agora",
        phone: "Número de telefone *",
      },
      locationTab: {
        info: "📍 Envie uma localização para o cliente.",
        messageText: "Texto da mensagem",
        locationName: "Nome do local",
        address: "Endereço",
        latitude: "Latitude *",
        longitude: "Longitude *",
      },
      carouselTab: {
        info: "🎠 Envie múltiplos cards como carrossel.",
        messageText: "Texto da mensagem *",
        card: "Card",
        title: "Título",
        description: "Descrição",
        addCard: "Adicionar card",
      },
      catalogTab: {
        info: "🛍️ Envie produtos do catálogo como cards.",
        messageText: "Texto da mensagem *",
        product: "Produto",
        productName: "Nome do produto",
        descriptionPrice: "Descrição / Preço",
        addProduct: "Adicionar produto",
      },
      pollTab: {
        info: "📊 Crie uma enquete para o cliente votar.",
        officialNote: "(Será enviada como texto formatado na API Oficial)",
        question: "Pergunta da enquete *",
        optionsMinMax: "Opções (mín. 2, máx. 12)",
        add: "Adicionar",
        option: "Opção",
      },
      billingTab: {
        info: "🧾 Envie uma cobrança com detalhes do pagamento e botão \"Revisar e pagar\".",
        billingNumber: "Nº da cobrança",
        billingDesc: "Descrição da cobrança *",
        billingDescPlaceholder: "Cobrança pensão das crianças",
        quantity: "Quantidade",
        totalAmount: "Valor total *",
        customMessage: "Mensagem personalizada",
        footer: "Rodapé (opcional)",
        attachPdf: "📄 Anexar PDF / Boleto (opcional)",
        selectPdf: "Selecionar PDF",
        paymentButton: "Botão de pagamento",
        buttonText: "Texto do botão",
        paymentUrl: "URL de pagamento (opcional)",
        paymentUrlHelper: "Se preenchido, o botão será um link clicável (CTA URL)",
        reviewAndPay: "Revisar e pagar",
        total: "Total",
        billingNumberLabel: "Nº DA COBRANÇA",
      },
    },
    pairingCodeModal: {
      title: "📱 Conectar via Código de Pareamento",
      instructions: "Informe o número do WhatsApp com",
      countryCode: "código do país + DDD",
      example: "Exemplo:",
      phoneLabel: "Número do WhatsApp",
      phonePlaceholder: "+55 (11) 99999-8888",
      digitsCount: "{{count}}/13 dígitos — código do país + DDD + número",
      generateCode: "Gerar Código",
      tryAgain: "Tentar Novamente",
      close: "Fechar",
      cancel: "Cancelar",
      connected: "Conectado!",
      connectedDesc: "WhatsApp pareado com sucesso. O modal fechará automaticamente.",
      alreadyConnected: "✅ WhatsApp já está conectado!",
      codeNotReturned: "Código de pareamento não retornado pelo servidor.",
      codeGenerated: "🔑 Código gerado! Digite-o no seu WhatsApp em até 60 segundos.",
      whatsappInstructions: "No seu WhatsApp, vá em:",
      whatsappSteps: "Configurações → Dispositivos Vinculados → Vincular um dispositivo",
      tapLinkPhone: "Toque em",
      linkWithPhone: "Vincular com número de telefone",
      enterCodeExact: "e insira o código exatamente como exibido (sem espaços):",
      waitingCode: "Aguardando código...",
      enterCodeInWhatsapp: "Insira o código no WhatsApp",
      codeExpiring: "Código expirando!",
      waitingPairing: "Aguardando você inserir o código no WhatsApp...",
      syncingSession: "Sincronizando sessão... Quase lá!",
      steps: {
        generateCode: "Gerar código",
        enterCode: "Digitar no WhatsApp",
        syncing: "Sincronizando",
        connected: "Conectado",
      },
    },
    campaignContactSelector: {
      newListTitle: "Nova Lista de Contatos",
      stepName: "Nomear lista",
      stepImport: "Importar contatos",
      nameDescription: "Dê um nome para identificar esta lista de contatos.",
      listName: "Nome da lista",
      namePlaceholder: "Ex: Clientes VIP, Prospects Novembro...",
      charsCount: "{{count}}/50 caracteres",
      listCreated: "Lista \"{{name}}\" criada! Agora importe os contatos (opcional).",
      dragExcel: "Arraste o Excel aqui ou clique para selecionar",
      acceptedFormats: "Formatos aceitos: .xls, .xlsx",
      downloadTemplate: "📥 Baixar planilha modelo (.xlsx)",
      close: "Fechar",
      cancel: "Cancelar",
      skipImport: "Pular importação",
      creating: "Criando...",
      createList: "Criar Lista →",
      sending: "Enviando...",
      importContacts: "Importar Contatos",
      selectedForCampaign: "✓ Lista selecionada para esta campanha",
      selectForCampaign: "Selecionar esta lista para a campanha",
      backToCampaign: "Voltar para a Campanha →",
      searchSystemContacts: "Buscar Contatos do Sistema",
      selected: "{{count}} selecionado(s)",
      addingToList: "Adicionando à lista: {{name}}",
      searchPlaceholder: "Buscar por nome ou número...",
      filterByTag: "Filtrar por tag:",
      clearFilters: "Limpar ({{count}})",
      loadingTags: "Carregando tags...",
      noTagsAvailable: "Nenhuma tag disponível.",
      selectAll: "Selecionar todos ({{count}} exibidos)",
      noContactsFound: "Nenhum contato encontrado.",
      tryAnotherSearch: "Tente buscar por outro nome ou número.",
      name: "Nome",
      number: "Número",
      loadMore: "Carregar mais",
      cancelSearch: "Cancelar",
      adding: "Adicionando...",
      addToList: "Adicionar {{count}} à lista",
      contactLists: "Listas de Contatos",
      createListsDesc: "Crie listas, importe contatos e selecione a lista que será usada nesta campanha.",
      simpleList: "Lista Simples",
      newListExcel: "Nova Lista + Excel",
      selectedList: "Lista selecionada: {{name}}",
      contactsCount: "{{count}} contatos — esta lista será usada na campanha",
      remove: "Remover",
      searchList: "Buscar lista...",
      noListsYet: "Nenhuma lista criada ainda.",
      clickNewList: "Clique em \"Nova Lista\" para começar.",
      selectedBadge: "Selecionada",
      contacts: "contatos",
      alreadySelected: "Lista já selecionada",
      selectForCampaignTooltip: "Selecionar para a campanha",
      searchSystemContactsTooltip: "Buscar contatos do sistema para esta lista",
      editList: "Editar lista",
      deleteList: "Excluir lista",
      deleteListConfirm: "Excluir a lista \"{{name}}\"?",
      listSelected: "Lista \"{{name}}\" selecionada para a campanha!",
      listRemoved: 'Lista removida com sucesso',
      importStarted: 'Importação iniciada! Os contatos serão carregados em breve.',
      invalidFormat: 'Formato inválido. Use apenas arquivos .xls ou .xlsx',
      fileUploaded: 'Arquivo enviado! Os contatos serão carregados em breve.',
      searchContact: 'Buscar contato...',
      selectThisList: 'Selecionar esta lista para a campanha',
      listSelectedToast: 'Lista "{{name}}" selecionada para a campanha!',
      nameList: 'Nomear lista',
      giveNameToList: 'Dê um nome para identificar esta lista de contatos.',
      listNamePlaceholder: 'Ex: Clientes VIP, Prospects Novembro...',
      characters: 'caracteres',
      searchByNameOrNumber: 'Buscar por nome ou número...',
      listAlreadySelected: 'Lista já selecionada',
      selectWhatsapp: 'Selecione uma conexão WhatsApp na campanha antes de importar.',
    },
    contactsPage: {
      importFromPhone: "Importar contatos do telefone",
      selectConnection: "Selecione a conexão WhatsApp de onde deseja importar os contatos:",
      noConnectionFound: "Nenhuma conexão WhatsApp conectada encontrada.",
      selectAConnection: "Selecione uma conexão",
      noNumber: "sem número",
      cancel: "Cancelar",
      import: "Importar",
      profilePhoto: "Foto de Perfil",
      imageNotAvailable: "Imagem não disponível",
      blockContact: "Bloquear Contato {{name}}?",
      unblockContact: "Desbloquear Contato {{name}}?",
      contactBlocked: "Contato bloqueado",
      contactUnblocked: "Contato desbloqueado",
      deleteAll: "Excluir Todos ({{count}})",
      deleteSelected: "Excluir Selecionados ({{count}})",
      delete: "Excluir",
      selectAtLeastOne: "Selecione pelo menos um contato para excluir",
      allDeleted: "Todos os {{count}} contatos foram excluídos",
      selectedDeleted: "{{count}} contatos excluídos com sucesso",
      importStarting: "Iniciando importação...",
      importSuccess: "Contatos importados com sucesso!",
      notSynced: "Contatos ainda não sincronizados. Conecte o celular e aguarde.",
      importError: "Erro ao importar contatos",
    },
    kanbanCard: {
      assignValue: "Atribuir Valor",
      value: "Valor: {{value}}",
      remove: "Remover",
      viewTicket: "Ver Ticket",
      editValue: "Editar",
      assignValueTitle: "Atribuir Valor da Oportunidade",
      editValueTitle: "Editar Valor da Oportunidade",
      valueLabel: "Valor",
      cancel: "Cancelar",
      save: "Salvar",
      noName: "Sem nome",
      noMessages: "Sem mensagens",
      pending: "Pendente",
      addValue: "Adicionar valor",
      viewChat: "Visualizar conversa",
      slaOnTime: "No prazo",
      slaWarning: "Atenção",
      slaOverdue: "Atrasado",
    },
    kanbanColumn: {
      searchPlaceholder: "Buscar por nome, número...",
      noResults: "Nenhum resultado",
      noTickets: "Nenhum ticket",
      slaOnTime: "No prazo",
      slaWarning: "Atenção",
      slaOverdue: "Atrasado",
      totalValue: "Valor total",
    },
    kanbanChat: {
      statusOpen: "Aberto",
      statusPending: "Pendente",
      statusClosed: "Fechado",
      contact: "Contato",
      noQueue: "Sem fila",
      noMessages: "Nenhuma mensagem ainda",
      inputPlaceholder: "Digite uma mensagem...",
    },
    tooltips: {
      edit: "Editar",
      delete: "Excluir",
      report: "Relatório",
      syncTemplates: "Sincronizar templates",
      copyWebhook: "Copiar webhook",
    },
    telegram: {
      botTokenTitle: "🤖 Token do Bot Telegram",
      botTokenHelp: "Crie um bot no @BotFather do Telegram e cole o token aqui. O webhook será configurado automaticamente ao salvar.",
      botTokenLabel: "Bot Token",
      webhookUrl: "Webhook URL",
      connectBot: "Conectar Bot",
      chip: "TELEGRAM",
    },
    locationPreview: {
      openInMaps: "Abrir no Google Maps",
    },
    flowBuilderConditionCompare: {
      saving: "Salvando...",
      saveChanges: "Salvar alterações",
      add: "Adicionar",
    },
    flowBuilderStart: {
      title: "Início do fluxo",
      description: "Este bloco marca o início do seu fluxo!",
    },
    flowBuilderConditionCompareNode: {
      title: "Se / Senão",
      contains: "contém",
      notContains: "não contém",
      containsAny: "contém algum",
      startsWith: "inicia com",
      endsWith: "termina com",
      isEmpty: "vazio",
      isNotEmpty: "não vazio",
      regex: "regex",
      field: "campo",
      value: "valor",
      and: "E",
      or: "OU",
      true: "Verdadeiro",
      false: "Falso",
    },
    flowBuilderHttpRequest: {
      title: "Requisição HTTP",
      preconfiguredWebhooks: "Webhooks Pré-configurados",
      selectPreset: "Selecionar preset",
      choosePreset: "Escolha uma configuração pronta...",
      system: "SISTEMA",
      remove: "Remover",
      usingPreset: "Usando preset:",
      urlFromPreset: "URL (do preset)",
      urlPlaceholder: "https://api.exemplo.com/webhook",
      editPresetUrl: "Você pode editar a URL base do preset se necessário",
      method: "Método",
      testRequest: "Testar Requisição",
      apiResponse: "Resposta da API:",
      viewFullResponse: "Ver resposta completa",
      hideAdvanced: "Ocultar avançado",
      showAdvanced: "Mostrar avançado",
      advancedWarning: "Configurações avançadas podem sobrescrever as configurações do preset",
      timeoutMs: "Timeout (ms)",
      queryParams: "Parâmetros de Query",
      key: "Chave",
      addParam: "Adicionar Parâmetro",
      headersJson: "Cabeçalhos (JSON)",
      requestBody: "Corpo da requisição (JSON)",
      editRequestBody: "Editar corpo da requisição",
      close: "Fechar",
      hideMapVars: "Ocultar Variáveis da Resposta",
      showMapVars: "Mapear Variáveis da Resposta",
      mapResponseData: "Mapear dados da resposta para variáveis",
      path: "Caminho",
      pathPlaceholder: "ex: data.user.id",
      variableName: "Nome da variável",
      variablePlaceholder: "ex: userId",
      addVariable: "Adicionar variável",
      tips: "Dicas úteis:",
      tipAutoSave: "A resposta completa da API é salva automaticamente na variável global",
      tipVarUsage: "Você pode usar ${nomeDaVariavel} no URL e corpo da requisição para incluir valores de variáveis.",
      requestError: "Erro na requisição",
      configSaved: "Configuração salva!",
      fullApiResponse: "Resposta completa da API",
      presetError: "Erro ao aplicar configuração do preset",
      value: "Valor",
    },
    flowBuilderInteractiveNode: {
      title: "Msg Interativa API",
      buttons: "Botões",
      maxButtons: "máx. 3",
      messageBody: "Corpo da mensagem...",
      select: "Selecionar",
      button: "Botão",
      item: "Item",
    },
    flowBuilderVariable: {
      title: "Variável Global",
      variableName: "Nome da variável",
      value: "Valor",
      helperText: "Você pode usar valores estáticos ou referências como ${outraVariavel}",
      saved: "Salvo!",
      saveVariable: "Salvar variável",
      variableSavedSuccess: "Variável salva com sucesso!",
    },
    flowBuilderAiAgent: {
      title: "Agente de IA",
      selectAgent: "Selecione um agente",
    },
    flowBuilderAttendant: {
      title: "Atendente",
    },
    flowBuilderAudioNode: {
      title: "Áudio",
      recordedLive: "Gravado na hora",
      audioSent: "Áudio enviado",
    },
    flowBuilderVideoNode: {
      title: "Vídeo",
    },
    flowBuilderMessageNode: {
      title: "Mensagem",
    },
    flowBuilderConditionNode: {
      title: "Condição",
    },
    flowBuilderImageNode: {
      title: "Imagem",
    },
    flowBuilderInputNode: {
      title: "Input",
      question: "Pergunta:",
      questionNotDefined: "Pergunta não definida",
      variableToStore: "Variável para armazenar resposta:",
      variableNotDefined: "Variável não definida",
      usingVariables: "Usando variáveis:",
      alwaysAsk: "Sempre perguntar (mesmo se variável já existir)",
    },
    flowBuilderMenuNode: {
      title: "Menu Numérico",
    },
    flowBuilderIntervalNode: {
      title: "Intervalo",
    },
    flowBuilderRandomizerNode: {
      title: "Randomizador",
    },
    flowBuilderSingleBlockNode: {
      title: "Conteúdo",
    },
    flowBuilderSwitchFlowNode: {
      title: "Trocar Fluxo",
    },
    flowBuilderTypebotNode: {
      title: "TypeBot",
    },
    flowBuilderQuestionNode: {
      title: "Pergunta",
    },
    flowBuilderTagNode: {
      title: "Tag",
    },
    flowBuilderTicketNode: {
      title: "Fila",
    },
    flowBuilderAiAgentModal: {
      addTitle: "Adicionar Agente de IA",
      editTitle: "Editar Agente de IA",
      add: "Adicionar",
      save: "Salvar",
      cancel: "Cancelar",
      selectAgent: "Selecione um Agente de IA",
      agentLabel: "Agente de IA",
      selectPlaceholder: "Selecione...",
      subtitle: "Selecione um agente ativo para usar neste fluxo",
      noAgentsFound: "Nenhum agente ativo encontrado. Crie um agente na página \"Agentes de IA\".",
      defaultAgentName: "Agente de IA",
    },
    flowBuilderValidation: {
      tooShort: "Muito curto!",
      tooLong: "Muito longo!",
      enterName: "Digite um nome!",
      enterMessage: "Digite uma mensagem!",
      required: "Obrigatório",
    },
    audioTranscription: {
      transcription: "Transcrição:",
      transcribing: "Transcrevendo...",
      transcribe: "Transcrever",
      failed: "Conversão para texto falhou",
    },
    birthdayModal: {
      congratulations: "🎉 Parabéns!",
      specialDay: "Hoje é um dia especial!",
      loading: "Carregando aniversariantes...",
      youLabel: "(Você!)",
      systemUser: "Usuário do Sistema",
      contact: "Contato",
      sending: "Enviando...",
      messageSent: "Mensagem já enviada",
      sendCongrats: "Enviar Parabéns",
      remindLater: "Lembrar mais tarde",
      understood: "Entendi, obrigado!",
      year: "ano",
      years: "anos",
      notAvailable: "N/A",
      toasts: {
        sent: "Mensagem de parabéns enviada para {{name}}! 🎉",
        alreadySent: "Mensagem de aniversário já foi enviada hoje para este contato",
        loadError: "Erro ao carregar aniversariantes",
        sendError: "Erro ao enviar mensagem de aniversário",
      },
    },
    birthdaySettings: {
      title: "🎂 Configurações de Aniversário",
      loading: "Carregando configurações...",
      userSection: "Aniversários de Usuários",
      contactSection: "Aniversários de Contatos",
      generalSection: "Configurações Gerais",
      enableUserNotifications: "Habilitar notificações de aniversário de usuários",
      enableUserNotificationsHelp: "Quando habilitado, será exibido modal de parabéns e criado informativo automático",
      createAnnouncementUsers: "Criar informativo automático para aniversários de usuários",
      createAnnouncementUsersHelp: "Cria um informativo automático que é exibido para todos os usuários da empresa",
      userBirthdayMessage: "Mensagem de aniversário para usuários",
      userMessageHelper: "Use {nome} para incluir o nome do usuário",
      enableContactMessages: "Habilitar envio automático de mensagens de aniversário para contatos",
      enableContactMessagesHelp: "Envia automaticamente mensagem de parabéns via WhatsApp para contatos aniversariantes",
      contactBirthdayMessage: "Mensagem de aniversário para contatos",
      contactMessageHelper: "Use {nome} para incluir o nome do contato e {idade} para a idade",
      testMessage: "Testar Mensagem",
      sendTime: "Horário de envio das mensagens",
      sendTimeHelper: "Horário em que as mensagens automáticas serão enviadas",
      whatsappConnection: "Conexão WhatsApp para Envio",
      selectConnection: "Selecione uma conexão",
      whatsappConnectionHelp: "Conexão WhatsApp que será usada para enviar mensagens de aniversário",
      createInternalAnnouncement: "Criar informativo interno para aniversários de usuários",
      createInternalAnnouncementHelp: "Cria um informativo interno quando um usuário faz aniversário",
      availableVariables: "Variáveis disponíveis nas mensagens:",
      varName: "Nome da pessoa",
      varAge: "Idade da pessoa (apenas para contatos)",
      preview: "Pré-visualização:",
      saving: "Salvando...",
      saveSettings: "Salvar Configurações",
      toasts: {
        saved: "Configurações de aniversário salvas com sucesso! 🎉",
        loadError: "Erro ao carregar configurações de aniversário",
        saveError: "Erro ao salvar configurações",
        testSent: "Mensagem de teste enviada! 📱",
        testError: "Erro ao enviar mensagem de teste",
      },
    },
    // (bloco campaignModal duplicado removido — todas as chaves foram mescladas no bloco principal acima, próximo à linha 2851)
    campaignModalPhrase: {
      campaignName: "Nome da campanha",
      nameRequired: "Nome é obrigatório",
      selectFlow: "Selecione um fluxo",
      flowRequired: "Fluxo é obrigatório",
      connections: "Conexões WhatsApp",
      connectionsMultiple: "(Múltiplas)",
      atLeastOneConnection: "Você deve selecionar pelo menos uma conexão",
      connectionsSelected: "{{count}} conexão(ões) selecionada(s):",
      connectionsInfo: "A campanha será executada quando qualquer conexão receber mensagens que correspondam às frases configuradas.",
      filterByTag: "Filtrar por Tag do Contato",
      optional: "(opcional)",
      filterByTagDesc: "Se selecionado, o fluxo só será disparado para contatos que tenham pelo menos uma destas tags.",
      tagsLabel: "Tags (opcional)",
      filterActive: "🏷️ Filtro ativo: o fluxo só será disparado para contatos com pelo menos uma das {{count}} tag(s) selecionada(s).",
      triggerKeywords: "Palavras-chave que disparam o fluxo",
      logicOr: "🔀 Lógica OU: o fluxo será disparado se o contato enviar qualquer uma das palavras/frases abaixo.",
      exactLabel: "Exata: mensagem idêntica.",
      partialLabel: "Parcial: palavra contida em qualquer parte da mensagem.",
      orChip: "OU",
      phraseLabel: "Palavra/frase {{index}}",
      phrasePlaceholder: "Ex: olá, quero orçamento...",
      fieldRequired: "Campo obrigatório",
      typeLabel: "Tipo",
      exact: "Exata",
      partial: "Parcial",
      addPhrase: "+ Adicionar outra palavra/frase (OU)",
      active: "Ativa",
      inactive: "Inativa",
      saving: "Salvando...",
      update: "Atualizar",
      create: "Criar",
      fillAllFields: "Por favor, preencha todos os campos obrigatórios",
      flowNotFound: "Fluxo selecionado não encontrado",
      toasts: {
        updated: "Campanha atualizada!",
        created: "Campanha criada!",
        saveError: "Erro ao salvar campanha",
        loadFlowsError: "Erro ao carregar fluxos",
        loadConnectionsError: "Erro ao carregar conexões",
        loadDataError: "Erro ao carregar dados da campanha",
      },
    },
    contactNotes: {
      deleteTitle: "Excluir Registro",
      deleteConfirm: "Deseja realmente excluir este registro?",
      noteAdded: "Observação adicionada com sucesso!",
      noteDeleted: "Observação excluída com sucesso!",
      cancel: "Cancelar",
      save: "Salvar",
      close: "Fechar",
    },
    contactDeleteConfirm: {
      titleAll: "Excluir TODOS os {{count}} contatos?",
      titleSelected: "Excluir {{count}} contatos selecionados?",
      warningAll: "⚠️ ATENÇÃO: Esta ação irá excluir TODOS os {{count}} contatos da empresa permanentemente!",
      warningAllBody: "Esta operação não pode ser desfeita. Todos os contatos, seus históricos de mensagens, tags e relacionamentos serão perdidos definitivamente.",
      warningSelected: "Esta ação irá excluir {{count}} contatos selecionados permanentemente.",
      warningSelectedBody: "Os contatos selecionados e seus dados relacionados serão excluídos definitivamente.",
      confirmPrompt: "Para confirmar, digite exatamente:",
      confirmLabel: "Confirmação",
      cancel: "Cancelar",
      deleteAll: "Excluir Todos",
      deleteSelected: "Excluir Selecionados",
      expectedAll: "EXCLUIR TODOS",
      expectedSelected: "EXCLUIR SELECIONADOS",
      typeExact: "Digite exatamente: {{text}}",
    },
    colorBoxModal: {
      title: "Escolha uma cor",
      cancel: "Cancelar",
      ok: "OK",
    },
    contactGroupModal: {
      title: "Criar Grupo de Contatos",
      groupName: "Nome do Grupo",
      groupNamePlaceholder: "Ex: Clientes VIP, Leads Janeiro...",
      searchPlaceholder: "Buscar contatos...",
      selectedCount: "{{count}} contato(s) selecionado(s)",
      clearSelection: "Limpar seleção",
      name: "Nome",
      number: "Número",
      email: "Email",
      tags: "Tags",
      noContacts: "Nenhum contato encontrado",
      perPage: "Por página:",
      displayedRows: "{{from}}-{{to}} de {{count}}",
      cancel: "Cancelar",
      creating: "Criando...",
      createGroup: "Criar Grupo ({{count}} contatos)",
      groupNameRequired: "Informe um nome para o grupo",
      selectAtLeastOne: "Selecione pelo menos um contato",
      groupCreated: "Grupo \"{{name}}\" criado com {{count}} contatos",
    },
    contactListTable: {
      name: "Nome",
      contacts: "Contatos",
      actions: "Ações",
    },
    contactTagListModal: {
      contacts: "Contatos",
      id: "ID",
      name: "Nome",
      number: "Número",
      actions: "Ações",
    },
    contactsFilter: {
      placeholder: "Contatos",
    },
    contactImport: {
      fields: {
        name: "Nome",
        number: "Número",
        email: "E-mail",
        birthDate: "Data de Nascimento",
        tags: "Tags",
        wallet: "Carteira",
      },
      errors: {
        noNumber: "Não foi selecionado o campo de número do contato",
        noName: "Não foi selecionado o campo de nome do contato",
        noSelection: "Nenhum contato selecionado",
        fieldAlreadySelected: "O campo {{field}} já foi selecionado.",
      },
      results: {
        title: "Resultado da importação",
        created: "✅ {{count}} contatos criados com sucesso",
        ignored: "⚠️ {{count}} contatos ignorados (número inválido ou não marcados para atualizar)",
        successAll: "Importação realizada com sucesso! {{count}} contatos importados.",
        successPartial: "Importação concluída: {{created}} contatos importados e {{ignored}} ignorados.",
        failed: "Falha na importação. Nenhum contato foi importado.",
        importMore: "Importar mais contatos",
      },
      validateSwitch: "Validar contatos no WhatsApp",
      uploading: "Importando... Aguarde",
      importButton: "Importar contatos",
      cancel: "Cancelar",
      processing: "Processando arquivo...",
      invalidFile: "Arquivo inválido!",
      invalidFileDesc: "O arquivo que você tentou importar não é válido. Por favor, tente novamente com um arquivo no formato correto.",
      tryAgain: "Tentar novamente",
      dropzoneTitle: "Clique ou arraste um arquivo Excel",
      dropzoneFormats: "* Formatos aceitos: xls, xlsx, csv, txt",
      dropzoneHelp: "Para importar contatos, você deve ter pelo menos as colunas de nome e número de telefone.",
      back: "Voltar",
    },
    contactImportWpModal: {
      importingPhone: "Importando contatos do telefone...",
      importPhoneButton: "📱 Importar contatos do telefone (WhatsApp)",
      phoneImported: "Contatos do telefone importados com sucesso!",
      statusInProgress: "importação em andamento {{current}} de {{total}} não saia desta tela até concluir a importação",
      statusComplete: "importação concluída com exito a importação",
    },
    contactDrawer: {
      noParticipants: "Nenhum participante encontrado",
      chat: "Conversar",
      superAdmin: "Super Admin",
      admin: "Admin",
      participant: "Participante",
      searching: "Buscando...",
      noMessages: "Nenhuma mensagem encontrada",
      searchPlaceholder: "Pesquisar nas mensagens...",
      infoTab: "Informações",
      imagesTab: "Imagens",
      videosTab: "Vídeos",
      audiosTab: "Áudios",
      documentsTab: "Documentos",
      linksTab: "Links",
      participantsTab: "Participantes",
      noImages: "Nenhuma imagem encontrada",
      noVideos: "Nenhum vídeo encontrado",
      noAudios: "Nenhum áudio encontrado",
      noDocs: "Nenhum documento encontrado",
      noLinks: "Nenhum link encontrado",
      contactUpdated: "Contato atualizado com sucesso!",
      contactBlocked: "Contato bloqueado",
      contactUnblocked: "Contato desbloqueado",
      blockTooltip: "Bloquear contato",
      unblockTooltip: "Desbloquear contato",
      lidWarning: "⚠️ Possível erro: Número parece ser LID",
      you: "(Você)",
      exportParticipants: "Exportar Participantes",
      noParticipantsExport: "Não há participantes para exportar",
      exportSuccess: "Arquivo \"{{name}}\" exportado com sucesso!",
      noName: "Sem nome",
    },
    companiesManager: {
      generateInvoice: "Gerar Fatura",
      yes: "Sim",
      no: "Não",
      loadError: "Não foi possível carregar a lista de registros",
      operationSuccess: "Operação realizada com sucesso!",
      operationError: "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
      deleteError: "Não foi possível realizar a operação",
    },
    birthdaySettingsPage: {
      title: "🎂 Configurações de Aniversário",
    },
    groupManager: {
      title: "Gestor de Grupos",
      groups: "Grupos",
      refresh: "Atualizar",
      sync: "Sincronizar Grupos",
      syncing: "Sincronizando...",
      clearAll: "Limpar todos os grupos",
      selectConnection: "Selecione uma conexão",
      selectConnectionFirst: "Selecione uma conexão para começar",
      clickSyncToLoad: "Clique em Sincronizar para carregar os grupos",
      connection: "Conexão",
      allConnections: "Todas as conexões",
      searchGroup: "Buscar grupo...",
      noGroupsFound: "Nenhum grupo encontrado",
      noName: "Sem nome",
      connectionLabel: "Conexão {{id}}",
      selectGroup: "Selecione um grupo",
      selectGroupDesc: "Escolha um grupo na lista para gerenciar",
      participants: "participantes",
      groupActions: "Ações do Grupo",
      changeName: "Alterar nome",
      changeNameDesc: "Mudar o nome do grupo",
      changeDescription: "Alterar descrição",
      changeDescriptionDesc: "Editar a descrição do grupo",
      inviteLink: "Link de convite",
      inviteLinkDesc: "Gerar ou copiar link de compartilhamento",
      addParticipants: "Adicionar participantes",
      addParticipantsDesc: "Adicionar pelo número do telefone",
      sendMessage: "Enviar mensagem",
      sendMessageDesc: "Enviar mensagem ao grupo com menção fantasma",
      settings: "Configurações",
      onlyAdminsSend: "Somente admins enviam",
      onlyAdminsSendDesc: "Apenas administradores podem enviar mensagens",
      restrictEdit: "Restringir edição",
      restrictEditDesc: "Somente admins editam dados do grupo",
      participantsCount: "Participantes ({{count}})",
      creator: "Criador",
      admin: "Admin",
      demoteAdmin: "Rebaixar de admin",
      promoteAdmin: "Promover a admin",
      removeFromGroup: "Remover do grupo",
      dialogChangeName: "Alterar nome do grupo",
      groupName: "Nome do grupo",
      cancel: "Cancelar",
      save: "Salvar",
      dialogChangeDesc: "Alterar descrição do grupo",
      description: "Descrição",
      dialogInviteLink: "Link de convite",
      close: "Fechar",
      dialogAddParticipants: "Adicionar participantes",
      phoneNumbers: "Número(s) do telefone",
      phoneNumbersPlaceholder: "5521999999999 (separe por vírgula para vários)",
      phoneNumbersHelper: "Informe o número com DDI+DDD, sem espaços. Ex: 5521999999999",
      add: "Adicionar",
      dialogSendMessage: "Enviar mensagem ao grupo",
      message: "Mensagem",
      mentionAll: "Mencionar todos os participantes (menção fantasma)",
      send: "Enviar",
      confirmRemoveParticipant: "Tem certeza que deseja remover este participante?",
      toasts: {
        loadError: "Erro ao carregar grupos",
        selectConnectionFirst: "Selecione uma conexão primeiro",
        syncSuccess: "{{count}} grupos sincronizados!",
        metadataError: "Erro ao carregar dados do grupo",
        nameUpdated: "Nome do grupo atualizado!",
        nameError: "Erro ao atualizar nome do grupo",
        descUpdated: "Descrição atualizada!",
        descError: "Erro ao atualizar descrição",
        inviteLinkError: "Erro ao gerar link de convite",
        linkCopied: "Link copiado!",
        participantAdded: "Participante(s) adicionado(s)!",
        participantAddError: "Erro ao adicionar participante",
        messageSent: "Mensagem enviada!",
        messageError: "Erro ao enviar mensagem",
        settingUpdated: "Configuração atualizada!",
        settingError: "Erro ao atualizar configuração",
        participantRemoved: "Participante removido!",
        removeError: "Erro ao remover participante",
        promoted: "Participante promovido a admin!",
        promoteError: "Erro ao promover participante",
        demoted: "Admin rebaixado!",
        demoteError: "Erro ao rebaixar participante",
      },
    },
    contactImportPage: {
      title: "Importar contatos de arquivo",
    },
    forwardMessageModal: {
      title: "Encaminhar mensagem",
      noContactFound: "Nenhum contato encontrado com o nome {{name}}",
      sending: "Enviando {{id}}...",
      forward: "Encaminhar",
    },
    newTicketModal: {
      selectQueue: "Selecione uma fila",
      selectConnection: "Selecione uma Conexão",
      createAndSendTemplate: "Criar e Enviar Template",
    },
    finalizacaoVendaModal: {
      title: "Finalização de Atendimento - Valor de Venda",
      loading: "Carregando configurações...",
      saleCompleted: "A venda foi concluída?",
      yes: "Sim, venda concluída",
      no: "Não, venda não concluída",
      saleValue: "Valor da Venda",
      noSaleReason: "Motivo da Não Venda *",
      finalizationReason: "Motivo da Finalização *",
      selectReason: "Selecione um motivo",
      cancel: "Cancelar",
      finalizing: "Finalizando...",
      finalize: "Finalizar Atendimento",
      errorSaleValue: "Por favor, informe o valor da venda.",
      errorNoSaleReason: "Por favor, selecione o motivo da não venda.",
      errorFinalizationReason: "Por favor, selecione o motivo da finalização.",
    },
    forbiddenPage: {
      title: "403",
      message: "Oops! Acesso Negado!",
      back: "Voltar",
    },
    showTicketLogModal: {
      close: "Fechar",
    },
    showTicketOpenModal: {
      close: "Fechar",
    },
        backupRestore: {
          backupTitle: "Backup do Banco de Dados",
          backupDescription: "Faça o download de uma cópia completa do banco de dados. Escolha o formato desejado:",
          backupSQL: "Backup SQL (.sql)",
          backupJSON: "Backup JSON (.json)",
          generating: "Gerando...",
          tip: "O backup SQL é ideal para restauração completa. O backup JSON é útil para análise e migração de dados.",
          restoreTitle: "Restaurar Banco de Dados",
          dangerZone: "Zona de perigo",
          dangerDescription: "A restauração irá sobrescrever todos os dados atuais do banco. Certifique-se de ter um backup atualizado antes de prosseguir.",
          restoring: "Restaurando...",
          uploadRestore: "Enviar arquivo .sql para restaurar",
          confirmRestore: "⚠️ ATENÇÃO: A restauração irá sobrescrever os dados atuais do banco. Tem certeza que deseja continuar? Recomendamos fazer um backup antes.",
          important: "Importante",
          importantText: "Após restaurar o backup, reinicie o servidor para que as conexões com Redis/Bull sejam recriadas corretamente.",
          toasts: {
            sqlSuccess: "Backup SQL baixado com sucesso!",
            sqlError: "Erro ao gerar backup SQL.",
            jsonSuccess: "Backup JSON baixado com sucesso!",
            jsonError: "Erro ao gerar backup JSON.",
            sqlOnly: "Apenas arquivos .sql são aceitos para restauração.",
            restoreSuccess: "Banco restaurado com sucesso! Recarregue a página.",
            restoreError: "Erro ao restaurar o banco de dados.",
          },
        },
        smtpSettings: {
          title: "Configurações SMTP",
          description: "Configure o servidor de e-mail para envio de códigos de recuperação de senha e notificações.",
          server: "Servidor SMTP",
          port: "Porta",
          secure: "Conexão segura (SSL/TLS na porta 465)",
          secureHelp: "Ative para usar SSL/TLS direto (porta 465). Desativado usa STARTTLS (porta 587).",
          senderEmail: "E-mail do Remetente",
          senderName: "Nome do Remetente",
          senderNameHelp: "Ex.: Equipechat. O e-mail remetente será o campo acima.",
          authentication: "Autenticação",
          authMethod: "Método de Autenticação",
          password: "Senha (Padrão)",
          passwordLabel: "Senha",
          gmailHelp: "Para Gmail, use uma \"Senha de App\" gerada em myaccount.google.com/apppasswords",
          save: "Salvar",
          testConfig: "Testar Configuração",
          testEmail: "E-mail para teste",
          sendTest: "Enviar Teste",
          toasts: {
            saveSuccess: "Configurações SMTP salvas com sucesso!",
            saveError: "Erro ao salvar configurações SMTP.",
            emailRequired: "Informe um e-mail para teste.",
            testSuccess: "E-mail de teste enviado com sucesso!",
            testError: "Falha ao enviar e-mail de teste. Verifique as configurações.",
          },
        },
        uploaderCert: {
          noPermission: "Sem permissão para acessar!",
          p12Only: "Use somente arquivos em formato p12!",
          chooseFile: "Escolha um arquivo!",
          chooseDestination: "Escolha um destino!",
          uploadSuccess: "Arquivo enviado com sucesso!",
          tabLabel: "Certificado Efí - API PIX (p12)",
          chooseOption: "Escolha uma opção:",
          certOption: "Certificado Efí p12 API PIX",
          chooseCert: "Escolher Certificado Efí p12 API PIX",
          submit: "ENVIAR CERTIFICADO",
        },
        triggerFlowModal: {
          selectRequired: "Selecione um fluxo para disparar",
          success: "Fluxo disparado com sucesso!",
          processingMessage: "Disparando fluxo... Campo de mensagem temporariamente desabilitado.",
        },
        queueOptions: {
          titlePlaceholder: "Título da opção",
          untitled: "Título não definido",
          messagePlaceholder: "Digite o texto da opção",
          add: "Adicionar",
          options: "Opções",
        },
        flowBuilderAudio: {
          toasts: {
            success: "Áudio adicionado com sucesso!",
            fileTooLarge: "Arquivo é muito grande! 5MB máximo",
          },
          captionLabel: "Legenda (opcional)",
          sendAudio: "Enviar audio",
          sendAsRecorded: "Enviar como audio gravado na hora",
        },
        common: {
          browserNoSupport: "Seu navegador não suporta HTML5",
        },
        flowBuilderVideo: {
          toasts: {
            success: "Vídeo adicionado com sucesso!",
            fileTooLarge: "Arquivo é muito grande! 20MB máximo",
          },
          sendVideo: "Enviar video",
          mp4Only: "ATENÇÃO! Apenas videos em MP4!",
        },
        flowBuilder: {
          condition: {
            commaSeparated: "Valores separados por vírgula",
            comparisonValue: "Valor da comparação",
            typeDollar: "Digite $ para ver variáveis disponíveis",
            regexHelper: "Ex: ^[0-9]{11}$ — expressão regular JavaScript",
            anyTokenHelper: "Qualquer token da lista dispara Verdadeiro",
            fixedOrVariable: "Valor fixo ou variável com $",
            insertVarSelector: "Inserir variável pelo seletor",
            errors: {
              variableRequired: "Condição {{num}}: o campo \"Variável / Campo\" é obrigatório",
              valueRequired: "Condição {{num}}: o campo \"Valor da comparação\" é obrigatório",
              saveError: "Ocorreu um erro ao salvar. Tente novamente.",
            },
            editCondition: "Editar Condição",
            newCondition: "Nova Condição",
            and: "E (AND)",
            or: "OU (OR)",
            addCondition: "Adicionar condição",
            logic: "Lógica: Verdadeiro se",
            allConditions: "TODAS as condições",
            anyCondition: "QUALQUER condição",
            areSatisfied: "forem satisfeitas",
            quickTips: "Dicas rápidas",
            containsAnyTip: "Contém qualquer (,): separe tokens por vírgula",
            regexTip: "Regex: use expressão JS",
            dynamicVarTip: "Use ${variavel} em qualquer campo para referenciar valores dinâmicos",
            selectVariable: "Selecionar variável",
            varsFound: "{{count}} variável(is) encontrada(s) no fluxo",
            addVarNodes: "Adicione nós de Variável Global ou Input para variáveis dinâmicas",
            searchVar: "Buscar variável...",
            noVarsFound: "Nenhuma variável encontrada",
            flowVariables: "Variáveis do fluxo",
          },
        },
        flowBuilderInteractive: {
          title: "Mensagem Interativa (Baileys)",
          editTitle: "Editar Mensagem Interativa",
          add: "Adicionar",
          save: "Salvar",
          selectDefault: "Selecionar",
          toasts: {
            messageRequired: "O corpo da mensagem é obrigatório!",
            addOption: "Adicione pelo menos uma opção!",
            imageError: "Erro ao enviar imagem",
            fileTooLarge: "Arquivo muito grande! Máximo 2MB",
          },
          preview: "Pré-visualização",
          messagePlaceholder: "Corpo da mensagem...",
          messageType: "Tipo de mensagem interativa",
          buttonsMax3: "Botões (máx. 3)",
          infoText: "Botões interativos via Baileys (nativeFlowMessage). Funciona em conexões não-oficiais. Limite de 3 botões.",
          tabContent: "CONTEÚDO DA MENSAGEM",
          messageBody: "Corpo da mensagem",
          footer: "Rodapé (opcional)",
          headerImage: "Imagem de cabeçalho (opcional)",
          changeImage: "Trocar imagem",
          uploadImage: "Enviar imagem",
          listButtonLabel: "Texto do botão da lista",
          listButtonHelper: "Texto exibido no botão que abre a lista",
          buttons: "Botões",
          listOptions: "Opções da lista",
          addAtLeastOne: "Adicione pelo menos uma opção.",
          button: "Botão",
        },
        flowBuilderSingleBlock: {
          addTitle: "Adicionar conteúdo ao fluxo",
          editTitle: "Editar conteúdo",
          addMenuTitle: "Adicionar menu ao fluxo",
          add: "Adicionar",
          save: "Salvar",
          message: "Mensagem",
          timeInSeconds: "Tempo em segundos",
          image: "Imagem",
          audio: "Audio",
          video: "Video",
          document: "Documento",
          text: "Texto",
          interval: "Intervalo",
          uploadImage: "Enviar imagem",
          uploadDocument: "Enviar Documento",
          uploading: "Subindo os arquivos e criando o conteúdo...",
          availableVars: "Variáveis disponíveis",
          toasts: {
            emptyMessage: "Campos de mensagem vazio!",
            invalidInterval: "Intervalo não pode ser 0 ou maior que 120!",
            fileTooLarge2MB: "Arquivo é muito grande! 2MB máximo",
            fileTooLarge5MB: "Arquivo é muito grande! 5MB máximo",
            fileTooLarge20MB: "Arquivo é muito grande! 20MB máximo",
            fileTooLarge10MB: "Arquivo é muito grande! 10MB máximo",
            success: "Conteúdo adicionado com sucesso!",
            deleteEmpty: "Delete os cards vazios (Imagem, Audio e Video)",
          },
          vars: {
            firstName: "Primeiro Nome",
            name: "Nome",
            userName: "Atendente",
            greeting: "Saudação",
            protocol: "Protocolo",
            date: "Data",
            hour: "Hora",
            ticketId: "Nº do Chamado",
            queue: "Setor",
            connection: "Conexão",
            phone: "Telefone",
            email: "E-mail",
            kanban: "Kanban",
          },
        },
    settingsOptions: {
      generalSettings: 'Configurações Gerais',
      schedulingBot: 'Agendamento & Bot',
      pushNotifications: 'Notificações Push',
      pushProcessing: 'Processando...',
      pushEnabled: '🔔 Push Ativado',
      pushDisabled: '🔕 Push Desativado',
      pushDescription: 'Ative para receber notificações push neste navegador quando houver novas mensagens.',
      pushDeactivated: 'Notificações push desativadas',
      pushActivated: 'Notificações push ativadas com sucesso!',
      pushActivateError: 'Não foi possível ativar as notificações push. Verifique as permissões do navegador.',
      pushVapidError: 'Push notifications não configuradas no servidor. Configure as chaves VAPID no backend.',
      pushChangeError: 'Erro ao alterar notificações push',
      systemCurrency: 'Moeda da Empresa',
      currency: 'Moeda',
      currencyDescription: 'Define o símbolo da moeda exibido nos valores de venda, relatórios, financeiro e checkout desta empresa.',
      currencyUpdated: 'Moeda atualizada com sucesso!',
      currencyPersistError: 'Falha ao persistir moeda',
      currencySaveError: 'Erro ao salvar moeda',
      currencyUpdateError: 'Erro ao atualizar moeda',
      operationUpdated: 'Operação atualizada com sucesso.',
      supportNumber: '📞 Número de Suporte',
      supportNumberPlaceholder: 'Ex: 5511999998888',
      supportNumberHelper: 'Número com código do país (usado no botão Chamar Suporte)',
      supportNumberUpdated: 'Número de suporte atualizado!',
      pixEfiConfig: 'Configuração Pix Efí (GerenciaNet)',
      pixKey: 'Chave PIX',
      tokenAsaas: 'Token Asaas',
      text: 'Texto',
      enabled: '✓ HABILITADO',
      disabledLabel: '✕ DESABILITADO',
      copyContactPrefix: 'Sigla para copiar contatos',
      aiSection: '🤖 Inteligência Artificial',
      autoAiSummary: 'Auto-resumo IA ao finalizar atendimento',
      aiSuggestReply: 'Sugerir Resposta com IA no Chat',
    },
    whitelabelSettings: {
      operationUpdated: 'Operação atualizada com sucesso.',
      appName: 'Nome do Aplicativo',
      appNameHelper: 'Nome exibido no navegador e e-mails',
      mobileAppName: 'Nome Mobile (PWA)',
      mobileAppNameHelper: 'Nome exibido ao instalar no celular',
      languages: {
        ptBR: 'Português',
        en: 'English',
        es: 'Español',
      },
    },
    campaignsPhrase: {
      deleted: 'Campanha deletada com sucesso',
      newCampaign: 'Nova Campanha',
      active: 'Ativo',
      inactive: 'Desativado',
      editCampaign: 'Editar campanha',
      deleteCampaign: 'Excluir campanha',
      noCampaigns: 'Nenhuma campanha encontrada',
      clickNewCampaign: 'Clique em "Nova Campanha" para criar sua primeira campanha de fluxo',
      name: 'Nome',
      connectionsCol: 'Conexões',
      statusCol: 'Status',
      nameNotDefined: 'Nome não definido',
      phrasesConfigured: 'frase(s) configurada(s)',
    },
    contactsPage: {
      notSynced: 'Contatos ainda não sincronizados. Conecte o celular e aguarde.',
      deleteAllContacts: 'Excluir todos os contatos',
      deleteSelectedContacts: 'Excluir contatos selecionados',
      cancelSelection: 'Cancelar seleção',
      deleteSelected: 'Excluir selecionados',
      status: 'Status',
      userNotFound: 'Usuário não encontrado',
      notAssigned: 'Não atribuído',
      openConversation: 'Abrir conversa',
    },
    financeiroPage: {
      paid: 'Pago',
      overdue: 'Vencido',
      open: 'Em Aberto',
      refunded: 'Estornada',
      yes: 'Sim',
      no: 'Não',
    },
    adminFinanceiro: {
      title: 'Gestão Financeira',
      totalRevenue: 'Receita Total',
      openInvoices: 'Faturas em Aberto',
      overdueInvoices: 'Faturas Vencidas',
      totalInvoices: 'Total de Faturas',
      paidInvoices: 'faturas pagas',
      allCompanies: 'Todas as empresas',
      statusDistribution: 'Distribuição por Status',
      revenueByMonth: 'Receita por Mês',
      defaultByMonth: 'Inadimplência por Mês',
      revenue: 'Receita',
      defaulting: 'Inadimplência',
      search: 'Buscar fatura...',
      filterStatus: 'Filtrar Status',
      all: 'Todos',
      paid: 'Pago',
      open: 'Em Aberto',
      overdue: 'Vencido',
      company: 'Empresa',
      detail: 'Detalhes',
      users: 'Usuários',
      connections: 'Conexões',
      value: 'Valor',
      dueDate: 'Vencimento',
      daysLeft: 'Dias',
      status: 'Status',
      daysRemaining: 'dias restantes',
      daysOverdue: 'dias em atraso',
      action: 'Ação',
      refund: 'Estornar',
      refunded: 'Estornada',
      refundTitle: 'Estornar fatura',
      refundMessage: 'Tem certeza que deseja estornar esta fatura?',
      refundSuccess: 'Fatura estornada com sucesso.',
    },
    companyFinanceiro: {
      title: 'Meu Plano & Financeiro',
      myPlan: 'Meu Plano',
      company: 'Empresa',
      users: 'Usuários',
      connections: 'Conexões',
      queues: 'Filas',
      value: 'Valor',
      daysLeft: 'dias restantes',
      daysOverdue: 'dias em atraso',
      expiresOn: 'Vence em',
      expiredTitle: 'Assinatura Vencida!',
      expiredMessage: 'Sua assinatura está vencida. Regularize para continuar usando o sistema.',
      availablePlans: 'Planos Disponíveis',
      currentPlan: 'Plano Atual',
      changePlan: 'Trocar Plano',
      earlyPayment: 'Pagamento Antecipado',
      month: 'mês',
      invoiceHistory: 'Histórico de Faturas',
      detail: 'Detalhes',
      dueDate: 'Vencimento',
      status: 'Status',
      action: 'Ação',
      pay: 'Pagar',
      refund: 'Estornar',
      refundTitle: 'Estornar fatura',
      refundMessage: 'Tem certeza que deseja estornar esta fatura?',
      refundSuccess: 'Fatura estornada com sucesso.',
      features: {
        campaigns: 'Campanhas',
        schedules: 'Agendamentos',
        internalChat: 'Chat Interno',
        integrations: 'Integrações',
        flows: 'Fluxos',
        contacts: 'Contatos',
        realTime: 'Tempo Real',
        kanban: 'Kanban',
        openai: 'OpenAI',
        telegram: 'Telegram',
        zapi: 'Z-API',
        dashboard: 'Painel',
      },
    },
    checkout: {
      almostDone: 'Falta pouco!',
      steps: { data: 'Dados', customize: 'Personalizar', review: 'Revisar' },
      back: 'VOLTAR',
      pay: 'PAGAR',
      next: 'PRÓXIMO',
      select: 'SELECIONAR',
      users: 'Usuários',
      connection: 'Conexão',
      queues: 'Filas',
      perMonth: '/mês',
      subscriptionSuccess: 'Assinatura realizada com sucesso!, aguardando a realização do pagamento',
      total: 'TOTAL',
      copied: 'Copiado',
      copyQrPix: 'Copiar código QR PIX',
      pixInstructions: 'Para finalizar, basta realizar o pagamento escaneando ou colando o código Pix acima ou escolha Pagar com Cartão de Crédito abaixo.',
      payWithCard: 'Pagar com Cartão de Crédito',
      payWithMercadoPago: 'Pagar com MercadoPago',
      payWithAsaas: 'Pagar com Asaas',
      licenseRenewed: 'Sua licença foi renovada até',
      subscriptionSummary: 'Resumo da assinatura',
      planDetails: 'Detalhes do plano',
      billing: 'Cobrança',
      monthly: 'Mensal',
      paymentInfo: 'Informação de pagamento',
      email: 'Email',
      name: 'Nome',
      cpfCnpj: 'CPF/CNPJ',
      fullName: 'Nome completo*',
      fullNameRequired: 'O nome completo é obrigatório',
      address: 'Endereço*',
      addressRequired: 'O Endereço é obrigatório',
      city: 'Cidade*',
      cityRequired: 'Cidade é obrigatória',
      state: 'Estado*',
      stateRequired: 'Estado é obrigatório',
      cpfCnpjLabel: 'CPF/CNPJ*',
      cpfCnpjRequired: 'CPF/CNPJ é obrigatório',
      country: 'País*',
      countryRequired: 'País é obrigatório',
    },
    chatPage: {
      loadUsersError: 'Erro ao carregar usuários',
      chatExists: 'Chat com este usuário já existe!',
      chatCreated: 'Chat criado com sucesso!',
      chatCreateError: 'Erro ao criar chat',
      group: 'Grupo',
      user: 'Usuário',
      internalChat: 'Chat interno nº ',
      chat: 'Chat',
      noMessages: 'Nenhuma mensagem',
      editGroup: 'Editar Grupo',
      createGroup: 'Criar Grupo',
      changeGroupPhoto: 'Alterar Foto do Grupo',
      addGroupPhoto: 'Adicionar Foto do Grupo',
      titleLabel: 'Título',
      titlePlaceholder: 'Título',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Descrição do grupo',
      editTimeLimit: 'Só é possível editar mensagens enviadas há menos de 10 minutos.',
      messageDeleted: 'Esta mensagem foi apagada',
      chatEditError: 'Erro ao criar/editar chat',
    },
    flowBuilderPage: {
      activeStatus: 'Ativo',
      inactiveStatus: 'Inativo',
      flowDeleted: 'Fluxo excluído com sucesso',
      flowDuplicated: 'Fluxo duplicado com sucesso',
      searchFlows: 'Buscar fluxos...',
      createFlow: 'Criar fluxo',
    },
    flowBuilderConfigPage: {
      basics: 'Básicos',
      start: 'Início',
      startDesc: 'Ponto inicial do fluxo',
      content: 'Conteúdo',
      contentDesc: 'Enviar texto, imagem, áudio ou vídeo',
      textNode: 'Texto',
      textDesc: 'Mensagem de texto simples',
      interaction: 'Interação',
      menu: 'Menu',
      menuDesc: 'Menu numérico de opções',
      interactiveApi: 'Msg Interativa API',
      interactiveApiDesc: 'Botões e listas (Baileys)',
      input: 'Input',
      inputDesc: 'Coletar entrada do usuário',
      interval: 'Intervalo',
      intervalDesc: 'Pausar execução por tempo',
      logic: 'Lógica',
      randomizer: 'Randomizador',
      randomizerDesc: 'Escolha aleatória de caminhos',
      ifElse: 'Se/Senão (If/Else)',
      ifElseDesc: 'Bifurcar fluxo com base em condição',
      system: 'Sistema',
      queues: 'Filas',
      queuesDesc: 'Gerenciar filas de atendimento',
      tags: 'Tags',
      tagsDesc: 'Adicionar tags ao contato',
      removeTag: 'Remover Tag',
      removeTagDesc: 'Remover tags do contato',
      switchFlow: 'Trocar Flow',
      switchFlowDesc: 'Direcionar para outro fluxo',
      attendant: 'Atendente',
      attendantDesc: 'Transferir para atendente',
      variable: 'Variável',
      variableDesc: 'Definir variáveis globais',
      aiAgent: 'Agente de IA',
      aiAgentDesc: 'Usar agente de IA configurado',
      httpRequest: 'HTTP Request',
      httpRequestDesc: 'Requisição HTTP externa',
      flowEditor: 'Editor de Fluxos',
    },
    templateMetaModal: {
      title: 'Templates do WhatsApp',
      searchPlaceholder: 'Pesquisar Templates',
      templateContent: 'Conteúdo do Template:',
      category: 'Categoria:',
      language: 'Idioma:',
      selectedDetails: 'Detalhes do Template Selecionado',
      name: 'Nome:',
      content: 'Conteúdo:',
      fillValue: 'Preencha o valor para',
      requiredField: 'Campo obrigatório',
      sendTemplate: 'Enviar Template',
      back: 'Voltar',
    },
    messagesAPIPage: {
      sendTextMedia: 'Enviar Texto / Mídia',
      yourMessageHere: 'Sua mensagem aqui',
      sendImageUrl: 'Enviar Imagem por URL',
      imageCaption: 'Legenda da imagem',
      sendNoTicket: 'Envio Rápido (Sem Ticket)',
      messageNoTicket: 'Mensagem sem ticket',
      batchSend: 'Envio em Lote',
      interactiveMessages: 'Mensagens Interativas',
      chooseOption: 'Escolha uma opção:',
      optionalFooter: 'Rodapé opcional',
      sales: 'Vendas',
      support: 'Suporte',
      financial: 'Financeiro',
      // Sidebar
      sidebar: {
        playground: 'PLAYGROUND',
        history: 'HISTÓRICO',
        intro: 'INTRODUÇÃO',
        messages: 'API DE MENSAGENS',
        contacts: 'CONTATOS',
        tickets: 'TICKETS / CONVERSAS',
        testEndpoint: 'Testar Endpoint',
        searchEndpoint: 'Buscar endpoint...',
        requestCount: 'requisição(ões)',
        clearHistory: 'Limpar histórico',
        noRequests: 'Nenhuma requisição ainda',
        remove: 'Remover',
        supportsGroups: 'Suporta grupos',
        docSubtitle: 'Documentação completa — {{count}} endpoints',
      },
      // Intro items
      introItems: {
        auth: 'Autenticação',
        rateLimit: 'Rate Limiting',
        errorCodes: 'Códigos de Erro',
      },
      // Endpoint labels
      endpoints: {
        checkNumber: 'Verificar Número',
        listConnections: 'Listar Conexões',
        listContacts: 'Listar Contatos',
        showContact: 'Buscar Contato',
        createContact: 'Criar Contato',
        updateContact: 'Atualizar Contato',
        deleteContact: 'Deletar Contato',
        listTickets: 'Listar Tickets',
        showTicket: 'Buscar Ticket',
        createTicket: 'Criar Ticket',
        updateTicket: 'Atualizar Ticket',
        deleteTicket: 'Deletar Ticket',
        closeAllTickets: 'Fechar Todos os Tickets',
        messagesRange: 'Mensagens por Período',
      },
      // Playground UI
      playground: {
        title: 'API Playground',
        desc: 'Teste os endpoints da sua API diretamente aqui. Informe a URL base do servidor e seu token de autenticação.',
        apiUrl: 'URL da API',
        token: 'Token',
        copyCurl: 'Copiar cURL',
        selectEndpoint: 'Selecionar endpoint pré-definido',
        group: 'Grupo',
        send: 'Enviar',
        uploadMedia: 'Upload Mídia',
        formatJson: 'Formatar JSON',
        mediaHint: 'Imagem, vídeo, áudio ou documento. Também funciona para grupos!',
        error: 'Erro',
        response: 'Resposta',
        yourToken: '<seu_token>',
      },
      // Badges
      badges: {
        new: 'NOVO',
        required: 'obrigatório',
        optional: 'opcional',
      },
      // Docs
      docs: {
        authTitle: 'Autenticação',
        authDesc: 'Todos os endpoints exigem autenticação via token Bearer. O token deve ser cadastrado na conexão WhatsApp através do menu <b>Conexões → Editar → Token</b>.',
        rateLimitTitle: 'Rate Limiting',
        rateLimitDesc: 'Para evitar bloqueios do WhatsApp, recomenda-se um intervalo mínimo de <b>2 segundos</b> entre envios. No envio em lote, utilize o parâmetro <code>delay</code> para controlar o intervalo.',
        errorCodesTitle: 'Códigos de Erro',
        messagesSection: 'API de Mensagens',
        contactsSection: 'Contatos',
        ticketsSection: 'Tickets / Conversas',
        // Table headers
        parameter: 'Parâmetro',
        type: 'Tipo',
        description: 'Descrição',
        code: 'Código',
        meaning: 'Significado',
        // Error codes
        success: 'Sucesso',
        invalidParams: 'Parâmetros inválidos ou ausentes',
        invalidToken: 'Token inválido ou não informado',
        notFound: 'Recurso não encontrado',
        serverError: 'Erro interno do servidor',
        // Send Text/Media
        sendTextTitle: 'Enviar Texto / Mídia',
        sendTextDesc: 'Envia mensagem de texto ou mídia (imagem, vídeo, áudio, documento) para contatos individuais ou <b>grupos</b>. Para enviar a um grupo, informe <code>"isGroup": true</code> e o JID do grupo no campo <code>number</code>.',
        paramNumber: 'Número do contato ou JID do grupo',
        paramBody: 'Texto da mensagem ou legenda da mídia',
        paramIsGroup: 'Se <code>true</code>, envia para grupo usando <code>@g.us</code>',
        paramMedias: 'Arquivo de mídia (multipart/form-data)',
        paramUserId: 'ID do atendente para atribuir',
        paramQueueId: 'ID da fila para direcionar',
        paramSendSignature: 'Incluir nome do atendente na mensagem',
        paramCloseTicket: 'Fechar ticket após envio',
        paramNoRegister: 'Enviar sem registrar ticket',
        // Send Image URL
        sendImageTitle: 'Enviar Imagem por URL',
        sendImageDesc: 'Envia imagem a partir de URL pública para contato ou <b>grupo</b>.',
        paramUrl: 'URL pública da imagem',
        paramCaption: 'Legenda',
        paramIsGroupSend: 'Se <code>true</code>, envia para grupo',
        // Send No Ticket
        sendNoTicketTitle: 'Envio Rápido (Sem Ticket)',
        sendNoTicketDesc: 'Envia mensagem de texto sem criar ticket. Funciona para contatos e <b>grupos</b>.',
        // Bulk
        bulkTitle: 'Envio em Lote (Bulk)',
        bulkDesc: 'Envia até 100 mensagens por lote. Cada mensagem pode ter <code>isGroup: true</code> individualmente.',
        // Buttons
        buttonsTitle: 'Mensagens Interativas',
        buttonsDesc: 'Envia mensagens interativas com botões, listas, URLs e PIX. Funciona para contatos e <b>grupos</b>.',
        // Check Number
        checkNumberTitle: 'Verificar Número',
        checkNumberDesc: 'Verifica se um número possui WhatsApp ativo.',
        // Contacts
        listContactsTitle: 'Listar Contatos',
        listContactsDesc: 'Retorna todos os contatos da empresa. Suporta paginação e busca.',
        paramSearchParam: 'Busca por nome, número ou email',
        paramPageNumber: 'Número da página (padrão: 1)',
        showContactTitle: 'Buscar Contato por ID',
        showContactDesc: 'Retorna os dados de um contato específico pelo ID.',
        createContactTitle: 'Criar Contato',
        createContactDesc: 'Cria um novo contato na base de dados.',
        paramName: 'Nome do contato',
        paramNumberWhatsApp: 'Número do WhatsApp com DDI+DDD',
        paramEmail: 'Email do contato',
        paramExtraInfo: 'Campos personalizados',
        updateContactTitle: 'Atualizar Contato',
        updateContactDesc: 'Atualiza os dados de um contato existente.',
        deleteContactTitle: 'Deletar Contato',
        deleteContactDesc: 'Remove permanentemente um contato. <b>Atenção:</b> Esta ação não pode ser desfeita.',
        // Tickets
        listTicketsTitle: 'Listar Tickets',
        listTicketsDesc: 'Retorna tickets com filtros por status, fila e atendente. Suporta paginação.',
        paramStatus: '<code>open</code>, <code>pending</code>, <code>closed</code>',
        paramQueueIds: 'IDs das filas separados por vírgula',
        paramSearchTicket: 'Busca por mensagem, contato ou ticket',
        paramShowAll: '<code>"true"</code> para listar todos os tickets',
        showTicketTitle: 'Buscar Ticket por ID',
        showTicketDesc: 'Retorna os detalhes completos de um ticket, incluindo contato, fila, atendente e mensagens.',
        createTicketTitle: 'Criar Ticket',
        createTicketDesc: 'Cria um novo ticket vinculado a um contato. Útil para iniciar conversas programaticamente.',
        paramContactId: 'ID do contato vinculado',
        paramStatusDefault: '<code>open</code>, <code>pending</code> (padrão: open)',
        paramQueueIdTicket: 'ID da fila',
        paramUserIdTicket: 'ID do atendente responsável',
        updateTicketTitle: 'Atualizar Ticket',
        updateTicketDesc: 'Atualiza status, fila ou atendente de um ticket. Útil para transferir ou fechar tickets via API.',
        paramNewQueueId: 'ID da nova fila',
        paramNewUserId: 'ID do novo atendente',
        deleteTicketTitle: 'Deletar Ticket',
        deleteTicketDesc: 'Remove permanentemente um ticket e suas mensagens. <b>Atenção:</b> Esta ação é irreversível.',
        closeAllTitle: 'Fechar Todos os Tickets',
        closeAllDesc: 'Fecha todos os tickets abertos de uma vez. Ideal para limpeza em lote.',
        messagesRangeTitle: 'Mensagens por Período',
        messagesRangeDesc: 'Retorna mensagens dentro de um intervalo de datas.',
        paramCompanyId: 'ID da empresa',
        paramStartDate: 'Data início (YYYY-MM-DD)',
        paramEndDate: 'Data fim (YYYY-MM-DD)',
        // Number/JID
        paramNumberOrJid: 'Número ou JID do grupo',
      },
    },
    templateManagerPage: {
      title: 'Gerenciamento de Templates',
      connection: 'Conexão',
      search: 'Buscar...',
      syncTooltip: 'Sincronizar com Meta',
      sync: 'Sync',
      createTemplate: 'Criar Template',
      submitApproval: 'Enviar para Aprovação',
      noOfficialConnection: 'Nenhuma conexão de API Oficial encontrada. Adicione uma conexão oficial para gerenciar templates.',
      noTemplatesFound: 'Nenhum template encontrado. Clique em "Sync" para sincronizar ou "Criar Template" para criar um novo.',
      tableName: 'Nome',
      tableCategory: 'Categoria',
      tableLanguage: 'Idioma',
      tableStatus: 'Status',
      tableActions: 'Ações',
      viewDetails: 'Ver detalhes',
      editTemplate: 'Editar (recriar template)',
      deleteTemplate: 'Excluir template',
      marketing: 'Marketing',
      utility: 'Utilidade',
      authentication: 'Autenticação',
    },
    userPerformance: {
      title: 'Desempenho dos Atendentes',
      subtitle: 'Análise detalhada do desempenho individual de cada atendente',
      fetchError: 'Erro ao carregar dados de desempenho',
      loading: 'Carregando...',
      noData: 'Nenhum dado encontrado para o período selecionado',
      summary: {
        totalTickets: 'Total de Tickets',
        activeUsers: 'Atendentes Ativos',
        avgSupportTime: 'Tempo Médio Atendimento',
        avgWaitTime: 'Tempo Médio Espera',
        avgRating: 'Avaliação Média',
      },
      charts: {
        ticketsByUser: 'Tickets por Atendente',
        statusDistribution: 'Distribuição por Status',
      },
      table: {
        title: 'Detalhamento por Atendente',
        user: 'Atendente',
        totalTickets: 'Total',
        open: 'Abertos',
        pending: 'Pendentes',
        closed: 'Finalizados',
        avgTime: 'Tempo Médio',
        avgWait: 'Espera Média',
        minTime: 'Menor Tempo',
        maxTime: 'Maior Tempo',
        rating: 'Avaliação',
        distribution: 'Distribuição',
      },
    },
    messagePreview: {
      title: "Pré-visualização",
      subtitle: "Veja como sua mensagem será exibida",
      contact: "Contato",
      online: "online",
      emptyState: "Nenhuma mensagem para visualizar",
      typePlaceholder: "Digite uma mensagem...",
      availableVars: "Variáveis disponíveis:",
      greetingExample: "Bom dia",
      attachedMedia: "Mídia anexada",
    },
    chatMessages: {
      clickToGoToOriginal: "Clique para ir à mensagem original",
      delete: "Excluir",
      deleted: "Mensagem apagada",
      deletedAdmin: "Mensagem apagada pelo admin",
      edit: "Editar",
      forward: "Encaminhar",
      forwarded: "Encaminhada",
      reply: "Responder",
      replyingTo: "Respondendo a",
    },
    contactDrawerBase: {
      editButton: "Editar",
      extraInfo: "Informações extras",
      header: "Dados do contato",
    },
    contactDrawerRoles: {
      admin: "Admin",
      superAdmin: "Super Admin",
    },
    contactImportWpModal: {
      title: "Importar Contatos do WhatsApp",
      downloadModel: "Baixar Modelo",
      importBtn: "Importar",
      closed: "Fechar",
    },
    contactListDialog: {
      dialog: "Lista de Contatos",
    },
    contactsFilters: {
      createdAt: "Data de criação",
      to: "Até",
    },
    contactsFilterConnections: {
      connections: "Conexões",
    },
    documentModal: {
      compressed: "Compactado",
      excel: "Excel",
      html: "HTML",
      json: "JSON",
      odpPresentation: "Apresentação ODP",
      odsSheet: "Planilha ODS",
      odt: "Documento ODT",
      ofx: "OFX",
      pdf: "PDF",
      ppt: "PowerPoint",
      word: "Word",
      xml: "XML",
    },
    flowBuilderAttendant: {
      add: "Adicionar",
      addAttendant: "Adicionar Atendente",
      chooseAttendant: "Escolha um atendente",
      edit: "Editar",
      editTitle: "Editar Atendente",
      selectUser: "Selecionar usuário",
      title: "Adicionar Atendente ao Fluxo",
    },
    flowBuilderImage: {
      add: "Adicionar",
      caption: "Legenda (opcional)",
      editTitle: "Editar Imagem",
      error: "Erro ao enviar imagem",
      fileTooLarge: "Arquivo muito grande!",
      save: "Salvar",
      successAdd: "Imagem adicionada com sucesso!",
      title: "Adicionar Imagem ao Fluxo",
      uploadImage: "Enviar imagem",
    },
    flowBuilderText: {
      add: "Adicionar",
      editTitle: "Editar Texto",
      message: "Mensagem",
      save: "Salvar",
      title: "Adicionar Texto ao Fluxo",
    },
    flowBuilderAI: {
      addKeyword: "Adicionar",
      aiObjective: "Objetivo da IA",
      apiKeyLabel: "Chave da API",
      assistantName: "Nome do Assistente",
      autoComplete: "Auto completar ao atingir objetivo",
      autoCompleteHelp: "A IA analisará se completou o objetivo",
      basicSettings: "Configurações Básicas",
      cancel: "Cancelar",
      continueKeywords: "Palavras-chave para Continuar Fluxo",
      flowBehavior: "Comportamento do Fluxo",
      flowBehaviorTooltip: "Configure como a IA deve se comportar no fluxo",
      keywordsHelp: "Quando o usuário enviar uma dessas palavras, o fluxo continuará",
      maxInteractions: "Máximo de Interações",
      maxInteractionsHelp: "Número máximo de mensagens antes de voltar ao fluxo",
      maxMessages: "Max Mensagens",
      maxMessagesHelp: "Histórico de contexto",
      maxTokensHelp: "Tamanho máximo da resposta",
      modelLabel: "Modelo",
      objectiveHelp: "Descreva o que a IA deve completar",
      objectivePlaceholder: "Ex: Coletar dados do cliente...",
      operatingMode: "Modo de Funcionamento",
      permanent: "Permanente",
      permanentDesc: "Encerrar fluxo aqui",
      permanentHelp: "O usuário segue conversando com a IA até pedir transferência",
      promptPlaceholder: "Descreva como a IA deve se comportar...",
      queueId: "ID da Fila (para transferência)",
      queueIdHelp: "ID da fila para transferir se o usuário pedir agente (0 = não transferir)",
      responseType: "Tipo de Resposta",
      systemPrompt: "Prompt do Sistema",
      temperature: "Temperatura",
      temperatureHelp: "0 = conservador, 2 = criativo",
      temporary: "Temporário",
      temporaryDesc: "Volta ao fluxo depois",
      temporaryHelp: "A IA executa uma tarefa específica e retorna ao fluxo normal",
      temporarySettings: "Configurações do Modo Temporário",
      temporarySettingsHelp: "Configure quando a IA deve parar e retornar ao fluxo",
      textOnly: "Apenas texto",
      timeout: "Timeout (minutos)",
      timeoutHelp: "Limite de tempo antes de voltar ao fluxo",
      typeKeyword: "Digite uma palavra-chave",
      voiceKeyLabel: "Chave de Voz",
      voiceKeyPlaceholder: "Chave da API de voz",
      voiceRegionLabel: "Região de Voz",
      voiceRegionPlaceholder: "Região da API de voz",
      voiceSettings: "Configurações de Voz",
    },
    n8nNodes: {
      webhook: "n8n Webhook",
      wait: "n8n Aguardar",
      query: "n8n Consulta",
      sendMessage: "n8n Mensagem",
      configureUrl: "Configurar URL do Webhook",
      configureQuery: "Configurar Consulta",
      configureWebhook: "Configurar Webhook",
      waitingReturn: "Aguardando retorno n8n",
      receiveAndSend: "Receber e enviar mensagem",
      sendsTicketData: "Envia dados do ticket",
      sendsContactData: "Envia dados do contato",
      queryN8n: "Consulta n8n",
      resultIn: "Resultado em",
      sendsResponseToClient: "Envia resposta ao cliente",
      waitsN8nResponse: "Aguarda resposta do n8n",
      field: "Campo",
      variable: "Var",
      saveIn: "Salvar em",
      error: "erro",
    },
    n8nModal: {
      editWebhook: "Editar n8n Webhook",
      editWait: "Editar n8n Aguardar Retorno",
      editQuery: "Editar n8n Consulta",
      editSendMessage: "Editar n8n Enviar Mensagem",
      addWebhook: "n8n - Webhook",
      addWait: "n8n - Aguardar Retorno",
      addQuery: "n8n - Consulta",
      addSendMessage: "n8n - Enviar Mensagem",
      nodeType: "Tipo de Nó n8n",
      webhookOption: "Webhook - Enviar dados",
      waitOption: "Aguardar Retorno - Pausar até callback",
      queryOption: "Consulta - Buscar e retornar dados",
      sendMessageOption: "Enviar Mensagem - Receber texto do n8n e enviar",
      webhookInfo: "Envia dados para um webhook do n8n. O fluxo continua imediatamente após o envio.",
      waitInfo: "Envia dados para o n8n e PAUSA o fluxo até receber um callback via POST /n8n-callback com os dados processados.",
      queryInfo: "Faz uma consulta síncrona ao n8n (ex: buscar dados de CRM/ERP) e salva a resposta em uma variável para uso no fluxo.",
      sendMessageInfo: "Envia dados do ticket/contato ao n8n, aguarda o texto processado na resposta e envia automaticamente como mensagem ao cliente.",
      webhookUrlLabel: "URL do Webhook n8n",
      webhookUrlPlaceholder: "https://seu-n8n.com/webhook/...",
      authTokenLabel: "Token de Autenticação (opcional)",
      authTokenPlaceholder: "Token para autenticar no n8n",
      dataToSend: "Dados a enviar",
      ticketData: "Dados do Ticket (ID, fila, status, etc.)",
      contactData: "Dados do Contato (nome, telefone, email)",
      lastMessage: "Última mensagem recebida",
      customPayload: "Payload customizado (JSON opcional)",
      waitConfig: "Configuração de Espera",
      timeoutMinutes: "Timeout (minutos)",
      timeoutHelper: "Tempo máximo de espera. Após isso, segue pelo handle 'timeout'.",
      saveResponseVar: "Variável para salvar resposta",
      saveResponseHelper: "A resposta do n8n será salva nesta variável. Use {{n8n_resultado}} nos próximos nós.",
      waitingMessage: "Mensagem enquanto aguarda (opcional)",
      queryConfig: "Configuração da Consulta",
      queryNameLabel: "Nome da Consulta",
      queryPayloadLabel: "Payload da consulta (JSON)",
      queryPayloadHelper: "Use {{variavel}} para inserir variáveis do fluxo",
      queryResultVar: "Variável para salvar resultado",
      queryResultHelper: "O resultado da consulta será salvo nesta variável",
      sendResultAsMessage: "Enviar resultado como mensagem ao cliente",
      messageTemplate: "Template da mensagem",
      messageTemplateHelper: "Use {{variavel}} para interpolar o resultado",
      sendConfig: "Configuração de Envio",
      responseFieldLabel: "Campo da resposta com a mensagem",
      responseFieldHelper: "O campo do JSON de resposta do n8n que contém o texto.",
      timeoutSeconds: "Timeout (segundos)",
      timeoutSecondsHelper: "Tempo máximo de espera pela resposta do n8n",
      saveResponseVarOptional: "Variável para salvar resposta (opcional)",
      saveResponseVarHelper: "Salva o texto retornado em uma variável para uso posterior",
      fallbackMessage: "Mensagem de fallback (se n8n falhar)",
      fallbackHelper: "Enviada ao cliente caso o n8n não responda ou ocorra erro",
      flowWarning: "Os dados do ticket e contato são enviados ao n8n → o n8n processa e retorna o texto → o texto é enviado automaticamente ao cliente via WhatsApp.",
      webhookRequired: "URL do Webhook é obrigatória",
      cancel: "Cancelar",
      save: "Salvar",
      add: "Adicionar",
    },
    n8nMonitor: {
      title: "Monitoramento n8n",
      total: "Total",
      success: "Sucesso",
      errors: "Erros",
      pending: "Pendentes",
      avgDuration: "Tempo Médio",
      successRate: "Taxa Sucesso",
      startDate: "Data Início",
      endDate: "Data Fim",
      status: "Status",
      nodeType: "Tipo de Nó",
      all: "Todos",
      webhook: "Webhook",
      waitReturn: "Aguardar Retorno",
      query: "Consulta",
      sendMessage: "Enviar Mensagem",
      id: "ID",
      dateTime: "Data/Hora",
      type: "Tipo",
      ticket: "Ticket",
      contact: "Contato",
      duration: "Duração",
      details: "Detalhes",
      noLogs: "Nenhum log encontrado",
      executionDetail: "Detalhes da Execução",
      nodeTypeLabel: "Tipo do Nó",
      webhookUrl: "URL do Webhook",
      errorMessage: "Mensagem de Erro",
      payloadSent: "Payload Enviado",
      responseReceived: "Resposta Recebida",
      noData: "Sem dados",
      close: "Fechar",
      loadError: "Erro ao carregar logs n8n",
      detailError: "Erro ao carregar detalhes",
      of: "de",
    },
    flowBuilderN8N: {
      integrations: "Integrações",
      webhookName: "n8n Webhook",
      webhookDesc: "Enviar dados para webhook n8n",
      waitName: "n8n Aguardar",
      waitDesc: "Pausar até retorno do n8n",
      queryName: "n8n Consulta",
      queryDesc: "Buscar dados via n8n",
      sendMessageName: "n8n Mensagem",
      sendMessageDesc: "Receber texto do n8n e enviar",
    },
    n8nMenuLabel: "Monitor n8n",
    n8nPanel: {
      title: "n8n Automações",
      refresh: "Atualizar",
      openInNewTab: "Abrir em nova aba",
      iframeBlocked: "Não foi possível carregar o n8n aqui",
      iframeBlockedHint: "O n8n pode estar bloqueando o carregamento em iframe. Configure N8N_SECURE_COOKIE=false no seu servidor n8n ou abra em uma nova aba.",
    },
    frontEndErrors: {
      getUsers: "Erro ao carregar usuários",
    },
    loadingText: {
      loading: "Carregando...",
    },
    showTicketLogModal: {
      header: "Log do Ticket",
      access: "Acessou",
      chatBot: "Chatbot",
      clientClosed: "Fechado pelo cliente",
      closed: "Fechado",
      create: "Criado",
      open: "Aberto",
      pending: "Pendente",
      queue: "Fila",
      receivedTransfer: "Recebeu transferência",
      redirect: "Redirecionado",
      reopen: "Reaberto",
      transfered: "Transferido",
    },
    showTicketOpenModal: {
      header: "Ticket em Aberto",
      message: "Mensagem",
      messageWait: "Mensagem de espera",
      queue: "Fila",
      user: "Atendente",
    },
    ticketListIntegration: {
      integrationTriggered: "Integração disparada com sucesso!",
    },
    campaignModalExtra: {
      preview: "Pré-visualização",
      seconds: "segundos",
    },
    messagesInputExtra: {
      internalMessage: "Mensagem interna",
      placeholderPending: "Digite uma mensagem para tickets pendentes",
      placeholderPendingAccept: "Aceite ou reabra este ticket para enviar uma mensagem.",
      placeholderWindowExpired: "Fora da janela de 24h. Use um template para enviar a mensagem.",
      ticketPendingTitle: "Ticket pendente.",
      ticketPendingMessage: "Aceite ou reabra este ticket para responder.",
      flowProcessingTitle: "Fluxo em Execução:",
      flowProcessingMessage: "Campo de mensagem temporariamente desabilitado.",
      windowExpiredTitle: "Janela de 24h Expirada:",
      windowExpiredMessage: "Recomendamos enviar um template, mas você também pode digitar normalmente.",
    },
    quickMessageExtra: {
      required: "Obrigatório",
      attachMedia: "Anexar mídia",
      editMedia: "Editar mídia",
      removeMedia: "Remover mídia",
      newFile: "Novo arquivo",
      newRecordedAudio: "Novo áudio gravado",
      newAudio: "Novo áudio",
      replaceMedia: "Escolha uma nova mídia para substituir:",
      chooseMedia: "Escolha uma opção para anexar mídia:",
      attachFile: "Anexar arquivo",
      recordAudio: "Gravar áudio",
      cancelEdit: "Cancelar edição",
      type: "Tipo",
      value: "Valor",
    },
    contactDrawerExtra: {
      admin: "Admin",
      chatAriaLabel: "Abrir conversa",
      contactPhoto: "Foto do contato",
      exportError: "Erro ao exportar participantes",
      group: "Grupo",
      nameCol: "Nome",
      noQueue: "Sem fila",
      numberCol: "Número",
      otherUser: "Outro usuário",
      participantsSheet: "Planilha de participantes",
      roleCol: "Papel",
      superAdmin: "Super Admin",
    },
    contactModalExtra: {
      birthDate: "Data de nascimento",
      birthDateHelper: "Formato: DD/MM/AAAA",
      lid: "LID",
      lidHelper: "Identificador LID do contato",
      noActiveFloup: "Nenhum fluxo ativo",
      noActiveFloupHelper: "Nenhum fluxo está ativo para este contato",
      noQueuesForUser: "Usuário não possui filas associadas",
      searchMinChars: "Digite pelo menos 3 caracteres para buscar",
      searching: "Buscando...",
      selectUserFirst: "Selecione um usuário primeiro",
      followUpPanel: "Painel FollowUP",
      aboutFollowUpTitle: "Sobre o Sistema Follow UP",
      aboutFollowUpDesc: "O Follow UP permite criar fluxos de mensagens e atribuí-los a um contato ou ticket para execução automática.",
      aboutFollowUpSelect: "Selecione um template ativo para iniciar. Você pode interromper a qualquer momento.",
      understood: "Entendi",
      noAgent: "Sem atendente",
    },
    fileModalExtra: {
      nameTooShort: "nome muito curto",
    },
    promptModalExtra: {
      sectorRequired: "Setor é obrigatório",
      text: "Texto",
    },
    queueModalExtra: {
      none: "Nenhuma",
    },
    scheduleModalExtra: {
      contactPlaceholder: "Digite para pesquisar o contato",
      fromQuickReply: "A partir da resposta rápida",
      messageStatus: "Status da mensagem",
      noQuickMessages: "Nenhuma resposta rápida encontrada",
      quickMessageSearch: "Buscar resposta rápida...",
      reminder: "Lembrete",
      reminderDate: "Data do lembrete",
      reminderDescription: "Descrição do lembrete",
      reminderNote: "Observação do lembrete",
      sendError: "Erro ao salvar agendamento",
    },
    tagModalExtra: {
      clickToAttach: "Clique para anexar",
      fileTooLarge: "Arquivo muito grande",
      maxSize: "Tamanho máximo",
      unsupportedType: "Tipo de arquivo não suportado",
    },
    ticketActionExtra: {
      disableBot: "Desabilitar bot",
      enableBot: "Habilitar bot",
      linkToWallet: "Vincular à carteira",
      ratingRequired: "Avaliação obrigatória",
      sendTemplate: "Enviar template",
      sendTemplateBtn: "Enviar",
      sendTemplateExpired: "⚠️ Janela de 24h expirada — envie um template para reabrir a conversa",
      templateSent: "Template enviado com sucesso!",
      ticketFinished: "Ticket finalizado",
      tokenError: "Erro de token",
    },
    ticketListExtra: {
      contactPhoto: "Foto do contato",
      createNewTicket: "Criar novo ticket",
      spyChatbot: "Espiar chatbot",
      ticketFinished: "Ticket finalizado",
    },
    reportsExtra: {
      statusDistribution: "Distribuição por Status",
      ticketsByQueue: "Tickets por Fila",
      ticketsByUser: "Tickets por Usuário",
      noQueue: "Sem fila",
      noUser: "Sem usuário",
      noDataForChart: "Sem dados para exibir",
    },
    flowDefaultPage: {
      title: "Fluxo padrão",
      welcomeFlow: "Fluxo de boas vindas",
      welcomeFlowDesc: "Este fluxo é disparado apenas para novos contatos, pessoas que você não possui em sua lista de contatos e que mandaram uma mensagem",
      defaultResponseFlow: "Fluxo de resposta padrão",
      defaultResponseFlowDesc: "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento já estiver fechado.",
      defaultResponseFlowDescLong: "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento já estiver fechado e passado 6 horas do seu fechamento.",
      disabled: "Desabilitado",
      chooseFlow: "Escolha um fluxo",
      disconnect: "Desconectar",
      save: "Salvar",
      deleteConfirm: "Tem certeza que deseja deletar este fluxo? Todas as integrações relacionados serão perdidos.",
    },
    flowBuilderPageExtra: {
      title: "Fluxos de Conversa",
      newFlow: "Novo Fluxo",
      importZip: "Importar (.zip)",
      noFlowFound: "Nenhum fluxo encontrado",
      noFlowCreated: "Nenhum fluxo criado ainda",
      tryOtherSearch: "Tente usar outros termos de pesquisa",
      createFirstFlowDesc: "Crie seu primeiro fluxo de conversa para automatizar atendimentos",
      createFirstFlow: "Criar Primeiro Fluxo",
    },
    floupPage: {
      title: "Follow UP - Templates de Fluxo",
      filterActive: "Ativo",
      filterError: "Com erros",
      filterPaused: "Pausado",
      filterAll: "Todos",
      subtitle: "Gerencie seus templates de Follow Up",
      newTemplate: "Novo Template",
      editTemplate: "Editar Template",
      basicInfo: "Informações Básicas",
      basicInfoDesc: "Configure o nome e tipo do seu Follow Up. O tipo define o template inicial das mensagens.",
      templateName: "Nome do Template",
      templateType: "Tipo do Template",
      description: "Descrição",
      client: "Cliente",
      lead: "Lead",
      customized: "Personalizado",
      triggerCondition: "Condição para Acionamento",
      triggerConditionDesc: "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
      condition: "Condição",
      systemQueue: "Fila do sistema",
      systemTag: "Tag do sistema",
      firstClientInteraction: "Primeira interação do cliente",
      firstAttendantInteraction: "Primeira interação do atendente",
      queue: "Fila",
      selectQueue: "Selecionar fila",
      tag: "Tag",
      selectTag: "Selecionar tag",
      conditionDescription: "Descrição da condição",
      conditionPlaceholder: "Ex: Cliente enviou primeira mensagem",
      flowSteps: "Passos do Fluxo",
      stepsDesc: "Configure as etapas do fluxo de Follow Up. Use as setas para reordenar.",
      addStep: "Adicionar Passo",
      removeStep: "Remover Passo",
      step: "Passo",
      emptyMessage: "Mensagem vazia",
      message: "Mensagem",
      variablesHint: "Variáveis: {{nome}}, {{protocolo}}, {{fila}}",
      interval: "Intervalo",
      unit: "Unidade",
      minutesLabel: "Minutos",
      hoursLabel: "Horas",
      daysLabel: "Dias",
      weeksLabel: "Semanas",
      monthsLabel: "Meses",
      attachment: "Anexo/Mídia",
      pasteUrl: "Cole a URL...",
      choose: "Escolher",
      uploadError: "Erro no upload.",
      conversationPreview: "Preview da Conversa",
      addStepsForPreview: "Adicione etapas para ver o preview",
      afterLabel: "Após",
      fileLabel: "Arquivo",
      flowStopControls: "Controles de Parada do Fluxo",
      stopControlsDesc: "Configure quando o Follow Up deve parar automaticamente.",
      stopAnyMessage: "1. Caso o Contato responder qualquer mensagem",
      stopKeyword: "2. Caso o Contato responder uma Palavra chave",
      keyword: "Palavra chave",
      keywordPlaceholder: "Ex: PARAR, CANCELAR, SAIR",
      stopTicketClosed: "3. Caso o Ticket for Fechado",
      noFlowsYet: "Nenhum Follow UP criado ainda",
      active: "Ativo",
      inactive: "Inativo",
      stepsCount: "etapas",
      queueLabel: "Fila",
      tagLabel: "Tag",
      interactionLabel: "Interação",
      edit: "Editar",
      duplicate: "Duplicar",
      delete: "Deletar",
      cancel: "Cancelar",
      previous: "Anterior",
      next: "Próximo",
      saveTemplate: "Salvar Template",
      confirmDeleteTitle: "Confirmar Exclusão",
      confirmDeleteMessage: "Tem certeza que deseja deletar o Follow UP",
      confirmDeleteWarning: "Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.",
    },
    floupSelector: {
      stopSuccess: "Follow UP interrompido para o contato com sucesso",
      stopError: "Erro ao interromper o Follow UP",
      active: "Ativo",
      newTemplate: "Novo Template",
      editTemplate: "Editar Template",
      basicInfo: "Informações Básicas",
      templateName: "Nome do Template",
      templateType: "Tipo do Template",
      description: "Descrição",
      triggerCondition: "Condição para Acionamento",
      triggerConditionDesc: "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
      condition: "Condição",
      systemQueue: "Fila do sistema",
      systemTag: "Tag do sistema",
      firstClientInteraction: "Primeira interação do cliente",
      firstAttendantInteraction: "Primeira interação do atendente",
      queue: "Fila",
      selectQueue: "Selecionar fila",
      tag: "Tag",
      selectTag: "Selecionar tag",
      conditionDescription: "Descrição da condição",
      conditionPlaceholder: "Ex: Cliente enviou primeira mensagem",
      flowStopControls: "Controles de Parada do Fluxo",
      stopAnyMessage: "1. Caso o Contato responder qualquer mensagem",
      stopKeyword: "2. Caso o Contato responder uma Palavra chave",
      keyword: "Palavra chave",
      keywordPlaceholder: "Ex: PARAR, CANCELAR, SAIR",
      stopTicketClosed: "3. Caso o Ticket for Fechado",
      flowSteps: "Passos do Fluxo",
      addStep: "Adicionar Passo",
      cancel: "Cancelar",
      saveTemplate: "Salvar Template",
      confirmDeleteTitle: "Confirmar Exclusão",
      confirmDeleteMessage: "Tem certeza que deseja deletar o Follow UP",
      confirmDeleteWarning: "Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.",
      delete: "Deletar",
      duplicate: "Duplicar",
      edit: "Editar",
      steps: "passos",
      active: "Ativo",
      inactive: "Inativo",
      customized: "Personalizado",
      client: "Cliente",
      lead: "Lead",
      basicInfoDesc: "Configure o nome e tipo do seu Follow Up. O tipo define o template inicial das mensagens.",
      stepsDesc: "Configure as etapas do fluxo de Follow Up. Use as setas para reordenar.",
      stopControlsDesc: "Configure quando o Follow Up deve parar automaticamente.",
      subtitle: "Gerencie seus templates de Follow Up",
      noFlowsYet: "Nenhum Follow UP criado ainda",
      step: "Passo",
      emptyMessage: "Mensagem vazia",
      message: "Mensagem",
      variablesHint: "Variáveis: {" + "{nome}}, {" + "{protocolo}}, {" + "{fila}}",
      interval: "Intervalo",
      unit: "Unidade",
      minutesLabel: "Minutos",
      hoursLabel: "Horas",
      daysLabel: "Dias",
      weeksLabel: "Semanas",
      monthsLabel: "Meses",
      attachment: "Anexo/Mídia",
      pasteUrl: "Cole a URL...",
      choose: "Escolher",
      uploadError: "Erro no upload.",
      removeStep: "Remover Passo",
      conversationPreview: "Preview da Conversa",
      addStepsForPreview: "Adicione etapas para ver o preview",
      afterLabel: "Após",
      fileLabel: "Arquivo",
      previous: "Anterior",
      next: "Próximo",
      queueLabel: "Fila",
      tagLabel: "Tag",
      interactionLabel: "Interação",
      stepsCount: "etapas",
    },
    templateManagerPageExtra: {
      createNewTemplate: "Criar Novo Template",
      templateNameLabel: "Nome do Template",
    },
    templateManagerForm: {
      rejected: "foi REJEITADO pela Meta",
      syncComplete: "Sincronização concluída",
      statusChanged: "com mudança de status",
      syncNoChanges: "Templates sincronizados - nenhuma mudança de status",
      tokenExpired: "⚠️ Token da API Oficial expirado ou inválido! Atualize o token de acesso da Meta na configuração da conexão.",
      nameBodyRequired: "Nome e corpo da mensagem são obrigatórios",
      nameValidation: "O nome do template deve conter apenas letras minúsculas, números e underscores (_)",
      sentForApproval: "Template enviado para aprovação da Meta!",
      deleteSuccess: "Template excluído com sucesso!",
      confirmDeleteMessage: "Esta ação irá excluir o template na Meta e localmente. Deseja continuar?",
      templateDetails: "Detalhes do Template",
      name: "Nome",
      language: "Idioma",
      status: "Status",
      category: "Categoria",
      components: "Componentes",
      close: "Fechar",
      nameHelper: "Apenas letras minúsculas, números e _",
      headerOptional: "Cabeçalho (opcional)",
      headerHelper: "Texto exibido no topo do template",
      messageBody: "Corpo da Mensagem",
      messageBodyHelper: "Use ｛｛1｝｝, ｛｛2｝｝, etc. para variáveis. Ex: Olá ｛｛1｝｝, seu pedido ｛｛2｝｝ está pronto!",
      footerOptional: "Rodapé (opcional)",
      footerHelper: "Texto pequeno no final do template",
      buttonsOptional: "Botões (opcional - máx 3)",
      quickReply: "Resposta Rápida",
      phone: "Telefone",
      text: "Texto",
      preview: "Pré-visualização",
      button: "Botão",
      cancel: "Cancelar",
    },
    whatsappModalRel: {
      form: {
        resolveAndTriggerIntegration: "Resolver e Disparar Integração",
        reportFilename: "Relatorio_Ticket_",
        elementNotFoundForExport: "Elemento não encontrado para exportação",
      },
    },
    announcementsPopover: {
      title: "Informativos",
      dontShowAgain: "Não exibir novamente",
      dismiss: "Não exibir",
      dismissAll: "Dispensar todos",
      close: "Fechar",
      backToList: "Voltar para lista",
      dismissedToast: "Este informativo não será mais exibido. Ele reaparecerá apenas quando houver novidades.",
      priority: {
        high: "Alta",
        medium: "Média",
        low: "Baixa",
      },
      priorityLabel: "Prioridade",
    },
    ticketsManagerExtra: {
      viewAll: "Todos",
      ascending: "Crescente",
      descending: "Decrescente",
      searchOnMessages: "Marque para pesquisar também nos conteúdos das mensagens (mais lento)",
    },
    announcementsPage: {
      noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      priorityHigh: "Alta",
      priorityMedium: "Média",
      priorityLow: "Baixa",
    },
    pairingCodeModalExtra: {
      phoneRequired: "Informe o número de telefone.",
      phoneTooShort: "Número muito curto. Inclua código do país + DDD.",
      phoneTooLong: "Número muito longo.",
      phoneBrazil: "Para números brasileiros, use 55 + DDD + número.",
      connectedSuccess: "✅ WhatsApp conectado com sucesso!",
      pairingFailed: "⚠️ Pareamento falhou. Tente novamente.",
      instructionText: "Informe o número do WhatsApp com",
      instructionHighlight: "código do país + DDD",
      exampleNumber: "5511999998888",
      digitsHelper: "dígitos — código do país + DDD + número",
      whatsappInstructions: "No seu WhatsApp, vá em:",
      whatsappSteps: "Configurações → Dispositivos Vinculados → Vincular um dispositivo",
      tapLink: "Toque em",
      linkWithPhone: "Vincular com número de telefone",
      enterCodeExact: "e insira o código exatamente como exibido (sem espaços):",
      stepCodeGenerated: "Código gerado",
      stepWaitingPairing: "Aguardando pareamento",
      stepSyncing: "Sincronizando",
      stepConnected: "Conectado",
    },
    newTicketOficialModal: {
      title: "Nova Conversa - API Oficial",
      selectQueue: "Selecione uma fila",
      selectOfficialConnection: "Selecione uma Conexão Oficial",
      selectQueuePlaceholder: "Selecione uma fila",
      selectConnectionPlaceholder: "Selecione uma Conexão Oficial",
      officialApiLabel: "API Oficial",
      createAndSendTemplate: "Criar e Enviar Template",
      templateSentSuccess: "Template enviado com sucesso!",
      selectQueueError: "Selecione uma fila",
      selectConnectionError: "Selecione uma conexão oficial",
    },
    interactiveMessageModalExtra: {
      sendInteractiveMessage: "Enviar Mensagem Interativa",
      modelsCount: "Modelos ({{count}})",
      saveCurrentConfig: "Salve a configuração atual como um modelo reutilizável para o tipo",
      saveButton: "Salvar",
      templateLoaded: "Template \"{{name}}\" carregado",
      buttonsInfo: "ℹ️ Envie até 3 botões clicáveis. O cliente pode tocar em um botão para responder rapidamente.",
      messageText: "Texto da mensagem *",
      footer: "Rodapé (opcional)",
      buttonsMax: "Botões (máx. 3)",
      add: "Adicionar",
      optionPlaceholder: "Opção {{n}}",
      listInfo: "ℹ️ Envie uma lista com até 10 opções. O cliente abre um menu para selecionar.",
      buttonText: "Texto do botão",
      sectionTitle: "Título da seção",
      titleLabel: "Título",
      descriptionLabel: "Descrição",
      addOption: "Adicionar opção",
      offerInfo: "🏷️ Envie uma oferta com título, preço e descrição.",
      offerTitle: "Título da oferta",
      offerBody: "Descrição / Corpo da mensagem *",
      offerPrice: "Preço (ex: 99,90)",
      offerDetails: "Detalhes adicionais",
      pixInfo: "💰 Envie dados PIX formatados para o cliente.",
      pixKey: "Chave PIX *",
      pixKeyPlaceholder: "CPF, CNPJ, e-mail, telefone ou chave aleatória",
      pixBeneficiary: "Nome do beneficiário",
      pixCity: "Cidade",
      pixAmount: "Valor",
      urlInfo: "🔗 Envie um link clicável com texto personalizado.",
      linkText: "Texto do link",
      linkPlaceholder: "Clique aqui",
      urlLabel: "URL *",
      callInfo: "📞 Envie uma mensagem com número para ligação.",
      callButtonText: "Texto do botão",
      callPlaceholder: "Ligar agora",
      callPhoneLabel: "Número de telefone *",
      locationInfo: "📍 Envie uma localização para o cliente.",
      locationMessageText: "Texto da mensagem",
      locationName: "Nome do local",
      locationAddress: "Endereço",
      latitudeLabel: "Latitude *",
      longitudeLabel: "Longitude *",
      carouselInfo: "🎠 Envie múltiplos cards como carrossel.",
      cardLabel: "Card {{n}}",
      cardTitle: "Título",
      cardDescription: "Descrição",
      addCard: "Adicionar card",
      catalogInfo: "🛍️ Envie produtos do catálogo como cards.",
      productLabel: "Produto {{n}}",
      productName: "Nome do produto",
      productDescription: "Descrição / Preço",
      addProduct: "Adicionar produto",
      pollInfo: "📊 Crie uma enquete para o cliente votar.",
      pollOfficialNote: "(Será enviada como texto formatado na API Oficial)",
      pollQuestion: "Pergunta da enquete *",
      pollOptionsLabel: "Opções (mín. 2, máx. 12)",
      billingInfo: "🧾 Envie uma cobrança com detalhes do pagamento e botão \"Revisar e pagar\".",
      billingNumber: "Nº da cobrança",
      billingDescription: "Descrição da cobrança *",
      billingQuantity: "Quantidade",
      billingTotalAmount: "Valor total *",
      billingCustomMessage: "Mensagem personalizada",
      billingAttachPdf: "📄 Anexar PDF / Boleto (opcional)",
      billingSelectPdf: "Selecionar PDF",
      billingPaymentButton: "Botão de pagamento",
      billingButtonText: "Texto do botão",
      billingPaymentUrl: "URL de pagamento (opcional)",
      billingPaymentUrlHelper: "Se preenchido, o botão será um link clicável (CTA URL)",
      billingNumberPreview: "Nº DA COBRANÇA",
      billingQuantityPreview: "Quantidade",
      billingTotal: "Total",
      billingDefaultBody: "Corpo da mensagem...",
      billingDefaultDescription: "Descrição da cobrança...",
      billingDefaultButton: "Revisar e pagar",
    },
    whatsAppModalExtra: {
      saturday: "Sábado",
      sunday: "Domingo",
      saveSchedulesHint: "Clique em salvar para registar as alterações",
    },
    tagsKanbanContainer: {
      label: "Etapa Kanban",
      selectStep: "Selecione uma etapa",
      selectKanbanStep: "Selecione uma Etapa Kanban",
      none: "Nenhuma",
      loadingSteps: "Carregando etapas...",
    },
    pendingTicketOverlay: {
      blockedTitle: "Conversa Bloqueada",
      blockedSubtitle: "Este ticket está aguardando aceite. Aceite a conversa para visualizar e responder às mensagens do cliente.",
      statusWaiting: "Status: Aguardando",
      contact: "Contato",
      ticketId: "Ticket #{{id}}",
      accepting: "Aceitando...",
      acceptConversation: "Aceitar Conversa",
      warningText: "🚫 Você não pode visualizar as mensagens antes de aceitar o ticket",
    },
    documentModalExtra: {
      viewDocument: "Visualizar Documento",
      open: "Abrir",
      download: "Download",
      emailOutlook: "E-mail Outlook",
      keynotePresentation: "Apresentação Keynote",
      numbersSpreadsheet: "Planilha Numbers",
      pagesDocument: "Documento Pages",
      executable: "Executável",
      retFile: "Arquivo RET",
      document: "Documento",
    },
    statusFilterExtra: {
      groups: "Grupos",
    },
    callReport: {
      title: "Relatório de Chamadas",
      subtitle: "Histórico completo de ligações realizadas e recebidas",
      exportCsv: "Exportar CSV",
      totalCalls: "Total de Chamadas",
      answered: "Atendidas",
      received: "Recebidas",
      errorsRejected: "Erros / Rejeitadas",
      callsByHour: "Chamadas por Hora",
      callsByDay: "Chamadas por Dia",
      callStatus: "Status das Chamadas",
      average: "Média",
      dateStart: "Data Início",
      dateEnd: "Data Fim",
      provider: "Conexão",
      attendant: "Atendente",
      status: "Status",
      all: "Todos",
      dateTime: "Data/Hora",
      phone: "Telefone",
      contact: "Contato",
      connection: "Conexão",
      duration: "Duração",
      recording: "Gravação",
      downloadRecording: "Baixar gravação",
      noRecords: "Nenhum registro encontrado",
      showing: "Mostrando",
      of: "de",
      completed: "Concluída",
      rejected: "Rejeitada",
      notAnswered: "Não Atendida",
      pending: "Pendente",
      system: "Sistema",
      sun: "Dom",
      mon: "Seg",
      tue: "Ter",
      wed: "Qua",
      thu: "Qui",
      fri: "Sex",
      sat: "Sáb",
    },
    hardcoded: {
      flowSavedSuccess: "Fluxo salvo com sucesso",
      flowSaveError: "Erro ao salvar o fluxo",
      flowDeletedSuccess: "Fluxo excluído com sucesso",
      flowDefaultsUpdated: "Fluxos padrões atualizados",
      mediaError: "Erro ao processar mídia",
      noDataFound: "Nenhum dado encontrado",
      selectFollowUp: "Selecione um Follow UP",
      chooseTemplate: "Escolher template...",
      noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      noPermissionShort: "Esta empresa não possui permissão para acessar essa página!",
      loadError: "Erro ao carregar dados de envio",
      generatingExcel: "Gerando relatório Excel, aguarde...",
      loadingData: "Carregando dados... {{count}} registros encontrados",
      noDataToExport: "Nenhum dado encontrado para exportar",
      excelReportHeader: "Relatório de Campanha",
      excelCampaignLabel: "Campanha: {{name}}",
      excelGeneratedAt: "Data de Geração: {{date}}",
      excelColId: "ID",
      excelColRecipient: "Destinatário",
      excelColMessage: "Mensagem",
      excelColSentAt: "Enviado em",
      excelColDeliveredAt: "Entregue em",
      excelColStatus: "Status",
      excelDelivered: "Entregue",
      excelPending: "Pendente",
      excelSheetName: "Relatório de Campanha",
      excelSuccess: "Relatório Excel gerado com sucesso! {{count}} registros exportados.",
      excelError: "Erro ao gerar relatório Excel",
      settingsSaved: "Configurações salvas",
      campaignDeleted: "Campanha deletada com sucesso",
      enterToken: "Informe o token de autenticação",
      requestSuccess: "✅ Requisição enviada com sucesso",
      requestLoaded: "Requisição carregada — clique Enviar para repetir",
      historyCleared: "Histórico limpo",
      copied: "Copiado!",
      invalidJson: "JSON inválido",
      chatCreated: "Chat criado com sucesso!",
      chatsGenerated: "Chats gerados com sucesso!",
      confirmBackfill: "Tem certeza que deseja gerar chats para todos os usuários existentes? Isso pode demorar e criar muitos chats.",
      walletNotFound: "Carteira não encontrada",
      maxButtonsReached: "Máximo de 3 botões permitidos",
      queueAcceptance: {
        kept: "Fila mantida",
        inherited: "Fila herdada da conexão"
      },
      schedulesUpdated: "Horários atualizados com sucesso.",
      pushDeactivateError: "Erro ao desativar notificações push",
      metaUpdated: "{{field}} atualizado!",
      clickSaveToRegister: "Clique em salvar para registar as alterações",
      contactsImported: "Contatos do WhatsApp importados com sucesso!",
      couldNotLoadRecords: "Não foi possível carregar a lista de registros",
      selectPeriod: "Por favor, selecione o período",
      fillAllFields: "Preencha todos os campos com valores numéricos válidos.",
      slaLimitsOrder: "Os limites devem ser crescentes: Verde < Amarelo < Vermelho.",
      slaUpdated: "Configurações de SLA atualizadas com sucesso!",
      slaError: "Erro ao salvar configurações de SLA.",
      cancelRequested: "Cancelamento solicitado. Aguarde a finalização do chat atual...",
      parameterizeFilter: "Parametrize o filtro",
      intervalValue: "Valor do Intervalo",
      sendHowManyTimes: "Enviar quantas vezes",
      sendNormallyNonBusiness: "Enviar normalmente em dias não úteis",
      sendBusinessDayBefore: "Enviar um dia útil antes",
      sendBusinessDayAfter: "Enviar um dia útil depois",
      showUser: "Mostrar Usuário",
      users: "Usuários",
      createTicket: "Criar Ticket",
      filterByTags: "Filtro por Tags",
      unknown: "Desconhecido",
      accessTicket: "Acessar Ticket",
      downloadFile: "Baixar arquivo",
      clickToDownload: "📎 Clique para baixar",
      select: "Selecionar",
      options: "Opções",
      reviewAndPay: "Revisar e pagar",
      followUpInfo: "Informações sobre Follow UP",
      salesReport: "Relatório de Vendas",
      startDate: "Data Inicial",
      endDate: "Data Final",
      agent: "Atendente",
      all: "Todos",
      generating: "Gerando...",
      generateReport: "Gerar Relatório",
      totalSales: "Total de Vendas",
      totalSalesValue: "Valor Total de Vendas",
      nonSales: "Não Vendas",
      avgTicketsPerAgent: "Média de Tickets por Atendente",
      nonSaleReasons: "Motivos de Não Venda",
      closedTickets: "Tickets Finalizados",
      saleValue: "Valor da Venda",
      nonSaleReason: "Motivo da Não Venda",
      closingReason: "Motivo da Finalização",
      closingReasonFilter: "Motivo da Finalização",
      nonSaleReasonFilter: "Motivo da Não Venda",
      agentPerformance: "Desempenho por Atendente",
      totalTickets: "Total de Tickets",
      avgTickets: "Média de Tickets",
      date: "Data",
      allowCrossQueueTicket: "Permitir abrir ticket em qualquer setor/conexão",
      refresh: "Atualizar",
      openNewTab: "Abrir em nova aba",
      whatsappConnection: "Conexão WhatsApp",
      tagUsed: "Tag Utilizada",
      notSpecified: "Não especificado",
      downloadSampleSheet: "Baixar Planilha Exemplo",
      saveFlow: "Salvar Fluxo",
      intervals: "Intervalos",
      // WavoipCall
      connected: "Conectado",
      connecting: "Conectando...",
      unknownNumber: "Número desconhecido",
      incomingCall: "Chamada recebida",
      readyForCalls: "Pronto para chamadas",
      connectingToServer: "Conectando ao servidor...",
      minimize: "Minimizar",
      backspace: "Apagar",
      unmute: "Desmutar",
      mute: "Mutar",
      endCall: "Encerrar",
      answerCall: "Atender",
      rejectCall: "Rejeitar",
      makeCall: "Ligar",
      typeNumberToCall: "Digite um número para ligar",
      calling: "Chamando...",
      inCall: "Em chamada",
      numberTooShort: "Número muito curto",
      numberTooLong: "Número muito longo",
      callError: "Erro ao realizar chamada",
      recordAudio: "Gravar Áudio",
      recording: "Gravando...",
      audioRecorded: "Áudio gravado",
      confirmOrDelete: "Clique em ✓ para confirmar ou 🗑️ para excluir",
      // FloupDashboard
      dashboardSubtitle: "Acompanhe o progresso dos seus fluxos de follow up",
      totalContacts: "Total Contatos",
      active: "Ativos",
      paused: "Pausados",
      withErrors: "Com Erros",
      steps: "Etapas",
      completionRate: "Taxa Conclusão",
      responseRate: "Taxa Resposta",
      contactDistribution: "Distribuição de contatos por etapa",
      searchContact: "Buscar contato...",
      allChannels: "Todos canais",
      allFilter: "Todos",
      withErrorsFilter: "Com Erros",
      pausedFilter: "Pausados",
      noContact: "Nenhum contato",
      noStepFound: "Nenhuma etapa encontrada",
      noHistoryFound: "Nenhum histórico encontrado",
      lastSendError: "Erro no último envio",
      step: "Etapa",
      resume: "Retomar",
      pause: "Pausar",
      history: "Histórico",
      timelineFollowUp: "Timeline de Follow Up",
      created: "Criado",
      sent: "Enviado",
      next: "Próximo",
      inactive: "Inativo",
      awaitingExecution: "Aguardando execução",
      awaitingExecutionShort: "Aguardando",
      // CampaignReport
      deliveryStatus: "Status de Entrega",
      delivered: "Entregues",
      waiting: "Aguardando",
      failures: "Falhas",
      messagesSent: "Mensagens Enviadas",
      uniqueRecipients: "Destinatários Únicos",
      messagesDelivered: "Mensagens Entregues",
      messageDetails: "Detalhes das Mensagens",
      exportExcel: "Exportar Excel",
      rowsPerPage: "Linhas por página:",
      chipDelivered: "Entregue",
      chipPending: "Pendente",
      chipFailed: "Falha",
      chipUnknown: "Desconhecido",
      loading: "Carregando...",
      noMessagesFound: "Nenhuma mensagem encontrada",
      notScheduled: "Não agendado",
      notCompleted: "Não concluído",
      // TemplateManager
      approved: "Aprovado",
      pending: "Pendente",
      rejected: "Rejeitado",
      // CampaignContactSelector
      noContactInList: "Nenhum contato nesta lista ainda.",
      importViaExcelOrWhatsapp: "Importe via Excel ou do WhatsApp usando os botões acima.",
      loadingTags: "Carregando tags...",
      noTagAvailable: "Nenhuma tag disponível.",
      selectAllShown: "Selecionar todos ({{count}} exibidos)",
      noContactFound: "Nenhum contato encontrado.",
      trySearchOther: "Tente buscar por outro nome ou número.",
      clickNewListToStart: "Clique em \"Nova Lista\" para começar.",
      filterByTag: "Filtrar por tag:",
      clearTags: "Limpar ({{count}})",
      addingToList: "Adicionando à lista:",
      addToList: "Adicionar {{count}} à lista",
      listCreatedImport: "Lista \"{{name}}\" criada! Agora importe os contatos (opcional).",
      dragExcelHere: "Arraste o Excel aqui ou clique para selecionar",
      acceptedFormats: "Formatos aceitos: .xls, .xlsx",
      downloadTemplate: "📥 Baixar planilha modelo (.xlsx)",
      skipImport: "Pular importação",
      nameListHint: "Dê um nome para identificar esta lista de contatos.",
      characters: "caracteres",
      listNameMinLength: "O nome deve ter pelo menos 2 caracteres.",
      listCreatedSuccess: "Lista \"{{name}}\" criada com sucesso!",
      contactsAddedToList: "{{count}} contato(s) adicionado(s) à lista \"{{name}}\"!",
      listSelectedForCampaign: "Lista \"{{name}}\" selecionada para a campanha!",
      backToCampaign: "Voltar para a Campanha →",
      excelModel: "Modelo Excel",
      importExcel: "Importar Excel",
      loadMore: "Carregar mais",
      contactLists: "Listas de Contatos",
      contactListsSubtitle: "Crie listas, importe contatos e selecione a lista que será usada nesta campanha.",
      simpleList: "Lista Simples",
      newListExcel: "Nova Lista + Excel",
      selectedListLabel: "Lista selecionada: {{name}}",
      selectedListDesc: "{{count}} contatos — esta lista será usada na campanha",
      remove: "Remover",
      deleteListConfirm: "Excluir a lista \"{{name}}\"?",
      // MessageUploadMedias
      addCaption: "Adicione uma legenda (opcional)",
      previewNotAvailable: "Visualização não disponível",
      // QueueFilter
      departments: "Departamentos",
      // MessageModal
      name: "Nome",
      // TagsContainer
      noTagFound: "Nenhuma tag encontrada. Digite para criar uma nova.",
      // Contacts import modal
      selectWhatsappConnection: "Selecione a conexão WhatsApp de onde deseja importar os contatos:",
      noWhatsappConnectionFound: "Nenhuma conexão WhatsApp conectada encontrada.",
      cancel: "Cancelar",
      import: "Importar",
      imageNotAvailable: "Imagem não disponível",
    },
    todoList: {
      title: "Lista de Tarefas",
      counter: "{{pending}} pendente(s) de {{total}} tarefa(s)",
      newTask: "Nova tarefa",
      editTask: "Editar tarefa",
      add: "Adicionar",
      save: "Salvar",
      cancel: "Cancelar",
      priority: "Prioridade",
      category: "Categoria",
      status: "Status",
      dueDate: "Vencimento",
      assignTo: "Atribuir a",
      nobody: "Ninguém",
      notes: "Observações",
      notesLabel: "Notas",
      search: "Buscar...",
      allTabs: "Todas",
      pendingTabs: "Pendentes",
      doneTabs: "Concluídas",
      allPriorities: "Todas",
      allUsers: "Todos",
      sortBy: "Ordenar",
      sortCreatedAt: "Data de criação",
      sortPriority: "Prioridade",
      sortDueDate: "Vencimento",
      sortManual: "Manual (arrastar)",
      user: "Usuário",
      priorities: { high: "Alta", medium: "Média", low: "Baixa" },
      statuses: { pending: "Pendente", in_progress: "Em Andamento", done: "Concluída" },
      categories: { general: "Geral", work: "Trabalho", personal: "Pessoal", urgent: "Urgente", study: "Estudo" },
      emptyNoTasks: "Nenhuma tarefa criada ainda",
      emptyFiltered: "Nenhuma tarefa encontrada",
      emptyAddFirst: "Adicione sua primeira tarefa acima!",
      emptyAdjustFilters: "Tente ajustar os filtros",
      dueSoonAlert: "tarefa(s) vence(m) em breve:",
      overdue: "Atrasada!",
      subtasks: "Subtarefas",
      newSubtask: "Nova subtarefa...",
      createdBy: "Criada por",
      assignedTo: "Atribuída a",
      deleteTitle: "Confirmar exclusão",
      deleteMessage: "Deseja realmente excluir esta tarefa?",
      deleteConfirm: "Excluir",
      toasts: {
        loadError: "Erro ao carregar tarefas",
        saveError: "Erro ao salvar tarefa",
        statusError: "Erro ao atualizar status",
        deleteError: "Erro ao excluir tarefa",
        subtaskError: "Erro ao atualizar subtarefas",
      },
    },
    accountSwitch: {
      title: "Suas Contas",
      subtitle: "Selecione uma conta para trocar automaticamente",
      addAccount: "Adicionar conta",
      savePassword: "Salvar Senha",
      saveCurrentPassword: "Salvar Senha da Conta Atual",
      email: "Email",
      password: "Senha",
      cancel: "Cancelar",
      save: "Salvar",
      admin: "Admin",
      agent: "Atendente",
      saved: "Salva",
      noPassword: "Sem senha",
      active: "ATIVA",
      passwordHelper: "A senha é salva localmente para troca rápida de conta",
      saveWarning: "Salve sua senha para habilitar troca rápida",
      toasts: {
        accountAdded: "Conta validada e adicionada!",
        invalidCredentials: "Credenciais inválidas. Verifique email e senha.",
        passwordSaved: "Senha salva com sucesso!",
        cannotRemoveActive: "Não é possível remover a conta ativa.",
        accountRemoved: "Conta removida.",
        noCredentials: "Credenciais não salvas. Salve a senha primeiro.",
        connectedAs: "Conectado como {{name}}",
      },
    },
  },
};

export { messages };
